/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** System capability details. */
export interface GetSystemInfoResponseCapabilities {
  /** True if signal and query headers are supported. */
  signalAndQueryHeader?: boolean;
  /**
   * True if internal errors are differentiated from other types of errors for purposes of
   * retrying non-internal errors.
   *
   * When unset/false, clients retry all failures. When true, clients should only retry
   * non-internal errors.
   */
  internalErrorDifferentiation?: boolean;
  /** True if RespondActivityTaskFailed API supports including heartbeat details */
  activityFailureIncludeHeartbeat?: boolean;
  /** Supports scheduled workflow features. */
  supportsSchedules?: boolean;
  /** True if server uses protos that include temporal.api.failure.v1.Failure.encoded_attributes */
  encodedFailureAttributes?: boolean;
  /**
   * True if server supports dispatching Workflow and Activity tasks based on a worker's build_id
   * (see:
   * https://github.com/temporalio/proposals/blob/a123af3b559f43db16ea6dd31870bfb754c4dc5e/versioning/worker-versions.md)
   */
  buildIdBasedVersioning?: boolean;
  /** True if server supports upserting workflow memo */
  upsertMemo?: boolean;
  /** True if server supports eager workflow task dispatching for the StartWorkflowExecution API */
  eagerWorkflowStart?: boolean;
  /**
   * True if the server knows about the sdk metadata field on WFT completions and will record
   * it in history
   */
  sdkMetadata?: boolean;
}

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 *
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 *
 * Example 1: Pack and unpack a message in C++.
 *
 *     Foo foo = ...;
 *     Any any;
 *     any.PackFrom(foo);
 *     ...
 *     if (any.UnpackTo(&foo)) {
 *       ...
 *     }
 *
 * Example 2: Pack and unpack a message in Java.
 *
 *     Foo foo = ...;
 *     Any any = Any.pack(foo);
 *     ...
 *     if (any.is(Foo.class)) {
 *       foo = any.unpack(Foo.class);
 *     }
 *
 * Example 3: Pack and unpack a message in Python.
 *
 *     foo = Foo(...)
 *     any = Any()
 *     any.Pack(foo)
 *     ...
 *     if any.Is(Foo.DESCRIPTOR):
 *       any.Unpack(foo)
 *       ...
 *
 * Example 4: Pack and unpack a message in Go
 *
 *      foo := &pb.Foo{...}
 *      any, err := anypb.New(foo)
 *      if err != nil {
 *        ...
 *      }
 *      ...
 *      foo := &pb.Foo{}
 *      if err := any.UnmarshalTo(foo); err != nil {
 *        ...
 *      }
 *
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 *
 *
 * JSON
 *
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 *
 *     package google.profile;
 *     message Person {
 *       string first_name = 1;
 *       string last_name = 2;
 *     }
 *
 *     {
 *       "@type": "type.googleapis.com/google.profile.Person",
 *       "firstName": <string>,
 *       "lastName": <string>
 *     }
 *
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 *
 *     {
 *       "@type": "type.googleapis.com/google.protobuf.Duration",
 *       "value": "1.212s"
 *     }
 */
export interface ProtobufAny {
  /**
   * A URL/resource name that uniquely identifies the type of the serialized
   * protocol buffer message. This string must contain at least
   * one "/" character. The last segment of the URL's path must represent
   * the fully qualified name of the type (as in
   * `path/google.protobuf.Duration`). The name should be in a canonical form
   * (e.g., leading "." is not accepted).
   *
   * In practice, teams usually precompile into the binary all types that they
   * expect it to use in the context of Any. However, for URLs which use the
   * scheme `http`, `https`, or no scheme, one can optionally set up a type
   * server that maps type URLs to message definitions as follows:
   *
   * * If no scheme is provided, `https` is assumed.
   * * An HTTP GET on the URL must yield a [google.protobuf.Type][]
   *   value in binary format, or produce an error.
   * * Applications are allowed to cache lookup results based on the
   *   URL, or have them precompiled into a binary to avoid any
   *   lookup. Therefore, binary compatibility needs to be preserved
   *   on changes to types. (Use versioned type names to manage
   *   breaking changes.)
   *
   * Note: this functionality is not currently available in the official
   * protobuf release, and it is not used for type URLs beginning with
   * type.googleapis.com.
   *
   * Schemes other than `http`, `https` (or the empty scheme) might be
   * used with implementation specific semantics.
   */
  "@type"?: string;
  [key: string]: any;
}

export interface RpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

export interface V1ActivityFailureInfo {
  /** @format int64 */
  scheduledEventId?: string;
  /** @format int64 */
  startedEventId?: string;
  identity?: string;
  activityType?: V1ActivityType;
  activityId?: string;
  retryState?: V1RetryState;
}

export interface V1ActivityPropertiesModifiedExternallyEventAttributes {
  /**
   * The id of the `ACTIVITY_TASK_SCHEDULED` event this modification corresponds to.
   * @format int64
   */
  scheduledEventId?: string;
  /**
   * If set, update the retry policy of the activity, replacing it with the specified one.
   * The number of attempts at the activity is preserved.
   */
  newRetryPolicy?: V1RetryPolicy;
}

export interface V1ActivityTaskCancelRequestedEventAttributes {
  /**
   * The id of the `ACTIVITY_TASK_SCHEDULED` event this cancel request corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
}

export interface V1ActivityTaskCanceledEventAttributes {
  /** Additional information that the activity reported upon confirming cancellation */
  details?: V1Payloads;
  /**
   * id of the most recent `ACTIVITY_TASK_CANCEL_REQUESTED` event which refers to the same
   * activity
   * @format int64
   */
  latestCancelRequestedEventId?: string;
  /**
   * The id of the `ACTIVITY_TASK_SCHEDULED` event this cancel confirmation corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /**
   * The id of the `ACTIVITY_TASK_STARTED` event this cancel confirmation corresponds to
   * @format int64
   */
  startedEventId?: string;
  /** id of the worker who canceled this activity */
  identity?: string;
}

export interface V1ActivityTaskCompletedEventAttributes {
  /** Serialized results of the activity. IE: The return value of the activity function */
  result?: V1Payloads;
  /**
   * The id of the `ACTIVITY_TASK_SCHEDULED` event this completion corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /**
   * The id of the `ACTIVITY_TASK_STARTED` event this completion corresponds to
   * @format int64
   */
  startedEventId?: string;
  /** id of the worker that completed this task */
  identity?: string;
}

export interface V1ActivityTaskFailedEventAttributes {
  /** Failure details */
  failure?: V1Failure;
  /**
   * The id of the `ACTIVITY_TASK_SCHEDULED` event this failure corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /**
   * The id of the `ACTIVITY_TASK_STARTED` event this failure corresponds to
   * @format int64
   */
  startedEventId?: string;
  /** id of the worker that failed this task */
  identity?: string;
  retryState?: V1RetryState;
}

export interface V1ActivityTaskScheduledEventAttributes {
  /** The worker/user assigned identifier for the activity */
  activityId?: string;
  activityType?: V1ActivityType;
  taskQueue?: V1TaskQueue;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
  input?: V1Payloads;
  /**
   * Indicates how long the caller is willing to wait for an activity completion. Limits how long
   * retries will be attempted. Either this or `start_to_close_timeout` must be specified.
   *
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  scheduleToCloseTimeout?: string;
  /**
   * Limits time an activity task can stay in a task queue before a worker picks it up. This
   * timeout is always non retryable, as all a retry would achieve is to put it back into the same
   * queue. Defaults to `schedule_to_close_timeout` or workflow execution timeout if not
   * specified.
   *
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  scheduleToStartTimeout?: string;
  /**
   * Maximum time an activity is allowed to execute after being picked up by a worker. This
   * timeout is always retryable. Either this or `schedule_to_close_timeout` must be
   * specified.
   *
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  startToCloseTimeout?: string;
  /** Maximum permitted time between successful worker heartbeats. */
  heartbeatTimeout?: string;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /**
   * Activities are assigned a default retry policy controlled by the service's dynamic
   * configuration. Retries will happen up to `schedule_to_close_timeout`. To disable retries set
   * retry_policy.maximum_attempts to 1.
   */
  retryPolicy?: V1RetryPolicy;
}

export interface V1ActivityTaskStartedEventAttributes {
  /**
   * The id of the `ACTIVITY_TASK_SCHEDULED` event this task corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /** id of the worker that picked up this task */
  identity?: string;
  /** TODO ?? */
  requestId?: string;
  /**
   * Starting at 1, the number of times this task has been attempted
   * @format int32
   */
  attempt?: number;
  /**
   * Will be set to the most recent failure details, if this task has previously failed and then
   * been retried.
   */
  lastFailure?: V1Failure;
}

export interface V1ActivityTaskTimedOutEventAttributes {
  /**
   * If this activity had failed, was retried, and then timed out, that failure is stored as the
   * `cause` in here.
   */
  failure?: V1Failure;
  /**
   * The id of the `ACTIVITY_TASK_SCHEDULED` event this timeout corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /**
   * The id of the `ACTIVITY_TASK_STARTED` event this timeout corresponds to
   * @format int64
   */
  startedEventId?: string;
  retryState?: V1RetryState;
}

/**
 * Represents the identifier used by a activity author to define the activity. Typically, the
 * name of a function. This is sometimes referred to as the activity's "name"
 */
export interface V1ActivityType {
  name?: string;
}

/** Alert contains notification and severity. */
export interface V1Alert {
  message?: string;
  severity?: V1Severity;
}

export interface V1ApplicationFailureInfo {
  type?: string;
  nonRetryable?: boolean;
  details?: V1Payloads;
}

/** @default "ARCHIVAL_STATE_UNSPECIFIED" */
export enum V1ArchivalState {
  ARCHIVAL_STATE_UNSPECIFIED = "ARCHIVAL_STATE_UNSPECIFIED",
  ARCHIVAL_STATE_DISABLED = "ARCHIVAL_STATE_DISABLED",
  ARCHIVAL_STATE_ENABLED = "ARCHIVAL_STATE_ENABLED",
}

export interface V1BackfillRequest {
  /**
   * Time range to evaluate schedule in.
   * @format date-time
   */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** Override overlap policy for this request. */
  overlapPolicy?: V1ScheduleOverlapPolicy;
}

export interface V1BadBinaries {
  binaries?: Record<string, V1BadBinaryInfo>;
}

export interface V1BadBinaryInfo {
  reason?: string;
  operator?: string;
  /** @format date-time */
  createTime?: string;
}

/**
 * BatchOperationCancellation sends cancel requests to batch workflows.
 * Keep the parameter in sync with temporal.api.workflowservice.v1.RequestCancelWorkflowExecutionRequest.
 * Ignore first_execution_run_id because this is used for single workflow operation.
 */
export interface V1BatchOperationCancellation {
  /** The identity of the worker/client */
  identity?: string;
}

/**
 * BatchOperationDeletion sends deletion requests to batch workflows.
 * Keep the parameter in sync with temporal.api.workflowservice.v1.DeleteWorkflowExecutionRequest.
 */
export interface V1BatchOperationDeletion {
  /** The identity of the worker/client */
  identity?: string;
}

export interface V1BatchOperationInfo {
  /** Batch job ID */
  jobId?: string;
  /** Batch operation state */
  state?: V1BatchOperationState;
  /**
   * Batch operation start time
   * @format date-time
   */
  startTime?: string;
  /**
   * Batch operation close time
   * @format date-time
   */
  closeTime?: string;
}

/**
 * BatchOperationSignal sends signals to batch workflows.
 * Keep the parameter in sync with temporal.api.workflowservice.v1.SignalWorkflowExecutionRequest.
 */
export interface V1BatchOperationSignal {
  /** The workflow author-defined name of the signal to send to the workflow */
  signal?: string;
  /** Serialized value(s) to provide with the signal */
  input?: V1Payloads;
  /**
   * Headers that are passed with the signal to the processing workflow.
   * These can include things like auth or tracing tokens.
   */
  header?: V1Header;
  /** The identity of the worker/client */
  identity?: string;
}

/** @default "BATCH_OPERATION_STATE_UNSPECIFIED" */
export enum V1BatchOperationState {
  BATCH_OPERATION_STATE_UNSPECIFIED = "BATCH_OPERATION_STATE_UNSPECIFIED",
  BATCH_OPERATION_STATE_RUNNING = "BATCH_OPERATION_STATE_RUNNING",
  BATCH_OPERATION_STATE_COMPLETED = "BATCH_OPERATION_STATE_COMPLETED",
  BATCH_OPERATION_STATE_FAILED = "BATCH_OPERATION_STATE_FAILED",
}

/**
 * BatchOperationTermination sends terminate requests to batch workflows.
 * Keep the parameter in sync with temporal.api.workflowservice.v1.TerminateWorkflowExecutionRequest.
 * Ignore first_execution_run_id because this is used for single workflow operation.
 */
export interface V1BatchOperationTermination {
  /** Serialized value(s) to provide to the termination event */
  details?: V1Payloads;
  /** The identity of the worker/client */
  identity?: string;
}

/** @default "BATCH_OPERATION_TYPE_UNSPECIFIED" */
export enum V1BatchOperationType {
  BATCH_OPERATION_TYPE_UNSPECIFIED = "BATCH_OPERATION_TYPE_UNSPECIFIED",
  BATCH_OPERATION_TYPE_TERMINATE = "BATCH_OPERATION_TYPE_TERMINATE",
  BATCH_OPERATION_TYPE_CANCEL = "BATCH_OPERATION_TYPE_CANCEL",
  BATCH_OPERATION_TYPE_SIGNAL = "BATCH_OPERATION_TYPE_SIGNAL",
  BATCH_OPERATION_TYPE_DELETE = "BATCH_OPERATION_TYPE_DELETE",
}

/**
 * CalendarSpec describes an event specification relative to the calendar,
 * similar to a traditional cron specification, but with labeled fields. Each
 * field can be one of:
 *   *: matches always
 *   x: matches when the field equals x
 *   x/y : matches when the field equals x+n*y where n is an integer
 *   x-z: matches when the field is between x and z inclusive
 *   w,x,y,...: matches when the field is one of the listed values
 * Each x, y, z, ... is either a decimal integer, or a month or day of week name
 * or abbreviation (in the appropriate fields).
 * A timestamp matches if all fields match.
 * Note that fields have different default values, for convenience.
 * Note that the special case that some cron implementations have for treating
 * day_of_month and day_of_week as "or" instead of "and" when both are set is
 * not implemented.
 * day_of_week can accept 0 or 7 as Sunday
 * CalendarSpec gets compiled into StructuredCalendarSpec, which is what will be
 * returned if you describe the schedule.
 */
export interface V1CalendarSpec {
  /** Expression to match seconds. Default: 0 */
  second?: string;
  /** Expression to match minutes. Default: 0 */
  minute?: string;
  /** Expression to match hours. Default: 0 */
  hour?: string;
  /**
   * Expression to match days of the month. Default: *
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: standard name of field --)
   */
  dayOfMonth?: string;
  /** Expression to match months. Default: * */
  month?: string;
  /** Expression to match years. Default: * */
  year?: string;
  /** Expression to match days of the week. Default: * */
  dayOfWeek?: string;
  /** Free-form comment describing the intention of this spec. */
  comment?: string;
}

/** @default "CANCEL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_UNSPECIFIED" */
export enum V1CancelExternalWorkflowExecutionFailedCause {
  CANCEL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_UNSPECIFIED = "CANCEL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_UNSPECIFIED",
  CANCEL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_EXTERNAL_WORKFLOW_EXECUTION_NOT_FOUND = "CANCEL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_EXTERNAL_WORKFLOW_EXECUTION_NOT_FOUND",
  CANCEL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_NAMESPACE_NOT_FOUND = "CANCEL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_NAMESPACE_NOT_FOUND",
}

export interface V1CancelTimerCommandAttributes {
  /** The same timer id from the start timer command */
  timerId?: string;
}

export interface V1CancelWorkflowExecutionCommandAttributes {
  details?: V1Payloads;
}

export interface V1CanceledFailureInfo {
  details?: V1Payloads;
}

export interface V1ChildWorkflowExecutionCanceledEventAttributes {
  details?: V1Payloads;
  /**
   * Namespace of the child workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  workflowType?: V1WorkflowType;
  /**
   * Id of the `START_CHILD_WORKFLOW_EXECUTION_INITIATED` event which this event corresponds to
   * @format int64
   */
  initiatedEventId?: string;
  /**
   * Id of the `CHILD_WORKFLOW_EXECUTION_STARTED` event which this event corresponds to
   * @format int64
   */
  startedEventId?: string;
}

export interface V1ChildWorkflowExecutionCompletedEventAttributes {
  result?: V1Payloads;
  /**
   * Namespace of the child workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  workflowType?: V1WorkflowType;
  /**
   * Id of the `START_CHILD_WORKFLOW_EXECUTION_INITIATED` event which this event corresponds to
   * @format int64
   */
  initiatedEventId?: string;
  /**
   * Id of the `CHILD_WORKFLOW_EXECUTION_STARTED` event which this event corresponds to
   * @format int64
   */
  startedEventId?: string;
}

export interface V1ChildWorkflowExecutionFailedEventAttributes {
  failure?: V1Failure;
  /**
   * Namespace of the child workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  workflowType?: V1WorkflowType;
  /**
   * Id of the `START_CHILD_WORKFLOW_EXECUTION_INITIATED` event which this event corresponds to
   * @format int64
   */
  initiatedEventId?: string;
  /**
   * Id of the `CHILD_WORKFLOW_EXECUTION_STARTED` event which this event corresponds to
   * @format int64
   */
  startedEventId?: string;
  retryState?: V1RetryState;
}

export interface V1ChildWorkflowExecutionFailureInfo {
  namespace?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  workflowType?: V1WorkflowType;
  /** @format int64 */
  initiatedEventId?: string;
  /** @format int64 */
  startedEventId?: string;
  retryState?: V1RetryState;
}

export interface V1ChildWorkflowExecutionStartedEventAttributes {
  /**
   * Namespace of the child workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Id of the `START_CHILD_WORKFLOW_EXECUTION_INITIATED` event which this event corresponds to
   * @format int64
   */
  initiatedEventId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  workflowType?: V1WorkflowType;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
}

export interface V1ChildWorkflowExecutionTerminatedEventAttributes {
  /**
   * Namespace of the child workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  workflowType?: V1WorkflowType;
  /**
   * Id of the `START_CHILD_WORKFLOW_EXECUTION_INITIATED` event which this event corresponds to
   * @format int64
   */
  initiatedEventId?: string;
  /**
   * Id of the `CHILD_WORKFLOW_EXECUTION_STARTED` event which this event corresponds to
   * @format int64
   */
  startedEventId?: string;
}

export interface V1ChildWorkflowExecutionTimedOutEventAttributes {
  /**
   * Namespace of the child workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  workflowType?: V1WorkflowType;
  /**
   * Id of the `START_CHILD_WORKFLOW_EXECUTION_INITIATED` event which this event corresponds to
   * @format int64
   */
  initiatedEventId?: string;
  /**
   * Id of the `CHILD_WORKFLOW_EXECUTION_STARTED` event which this event corresponds to
   * @format int64
   */
  startedEventId?: string;
  retryState?: V1RetryState;
}

export interface V1ClusterReplicationConfig {
  clusterName?: string;
}

export interface V1Command {
  /** Whenever this list of command types is changed do change the function shouldBufferEvent in mutableStateBuilder.go to make sure to do the correct event ordering. */
  commandType?: V1CommandType;
  scheduleActivityTaskCommandAttributes?: V1ScheduleActivityTaskCommandAttributes;
  startTimerCommandAttributes?: V1StartTimerCommandAttributes;
  completeWorkflowExecutionCommandAttributes?: V1CompleteWorkflowExecutionCommandAttributes;
  failWorkflowExecutionCommandAttributes?: V1FailWorkflowExecutionCommandAttributes;
  requestCancelActivityTaskCommandAttributes?: V1RequestCancelActivityTaskCommandAttributes;
  cancelTimerCommandAttributes?: V1CancelTimerCommandAttributes;
  cancelWorkflowExecutionCommandAttributes?: V1CancelWorkflowExecutionCommandAttributes;
  requestCancelExternalWorkflowExecutionCommandAttributes?: V1RequestCancelExternalWorkflowExecutionCommandAttributes;
  recordMarkerCommandAttributes?: V1RecordMarkerCommandAttributes;
  continueAsNewWorkflowExecutionCommandAttributes?: V1ContinueAsNewWorkflowExecutionCommandAttributes;
  startChildWorkflowExecutionCommandAttributes?: V1StartChildWorkflowExecutionCommandAttributes;
  signalExternalWorkflowExecutionCommandAttributes?: V1SignalExternalWorkflowExecutionCommandAttributes;
  upsertWorkflowSearchAttributesCommandAttributes?: V1UpsertWorkflowSearchAttributesCommandAttributes;
  protocolMessageCommandAttributes?: V1ProtocolMessageCommandAttributes;
  /** 16 is available for use - it was used as part of a prototype that never made it into a release */
  modifyWorkflowPropertiesCommandAttributes?: V1ModifyWorkflowPropertiesCommandAttributes;
}

/**
 * Whenever this list of command types is changed do change the function shouldBufferEvent in mutableStateBuilder.go to make sure to do the correct event ordering.
 * @default "COMMAND_TYPE_UNSPECIFIED"
 */
export enum V1CommandType {
  COMMAND_TYPE_UNSPECIFIED = "COMMAND_TYPE_UNSPECIFIED",
  COMMAND_TYPE_SCHEDULE_ACTIVITY_TASK = "COMMAND_TYPE_SCHEDULE_ACTIVITY_TASK",
  COMMAND_TYPE_REQUEST_CANCEL_ACTIVITY_TASK = "COMMAND_TYPE_REQUEST_CANCEL_ACTIVITY_TASK",
  COMMAND_TYPE_START_TIMER = "COMMAND_TYPE_START_TIMER",
  COMMAND_TYPE_COMPLETE_WORKFLOW_EXECUTION = "COMMAND_TYPE_COMPLETE_WORKFLOW_EXECUTION",
  COMMAND_TYPE_FAIL_WORKFLOW_EXECUTION = "COMMAND_TYPE_FAIL_WORKFLOW_EXECUTION",
  COMMAND_TYPE_CANCEL_TIMER = "COMMAND_TYPE_CANCEL_TIMER",
  COMMAND_TYPE_CANCEL_WORKFLOW_EXECUTION = "COMMAND_TYPE_CANCEL_WORKFLOW_EXECUTION",
  COMMAND_TYPE_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION = "COMMAND_TYPE_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION",
  COMMAND_TYPE_RECORD_MARKER = "COMMAND_TYPE_RECORD_MARKER",
  COMMAND_TYPE_CONTINUE_AS_NEW_WORKFLOW_EXECUTION = "COMMAND_TYPE_CONTINUE_AS_NEW_WORKFLOW_EXECUTION",
  COMMAND_TYPE_START_CHILD_WORKFLOW_EXECUTION = "COMMAND_TYPE_START_CHILD_WORKFLOW_EXECUTION",
  COMMAND_TYPE_SIGNAL_EXTERNAL_WORKFLOW_EXECUTION = "COMMAND_TYPE_SIGNAL_EXTERNAL_WORKFLOW_EXECUTION",
  COMMAND_TYPE_UPSERT_WORKFLOW_SEARCH_ATTRIBUTES = "COMMAND_TYPE_UPSERT_WORKFLOW_SEARCH_ATTRIBUTES",
  COMMAND_TYPE_PROTOCOL_MESSAGE = "COMMAND_TYPE_PROTOCOL_MESSAGE",
  COMMAND_TYPE_MODIFY_WORKFLOW_PROPERTIES = "COMMAND_TYPE_MODIFY_WORKFLOW_PROPERTIES",
}

export interface V1CompleteWorkflowExecutionCommandAttributes {
  result?: V1Payloads;
}

/**
 * - CONTINUE_AS_NEW_INITIATOR_WORKFLOW: The workflow itself requested to continue as new
 *  - CONTINUE_AS_NEW_INITIATOR_RETRY: The workflow continued as new because it is retrying
 *  - CONTINUE_AS_NEW_INITIATOR_CRON_SCHEDULE: The workflow continued as new because cron has triggered a new execution
 * @default "CONTINUE_AS_NEW_INITIATOR_UNSPECIFIED"
 */
export enum V1ContinueAsNewInitiator {
  CONTINUE_AS_NEW_INITIATOR_UNSPECIFIED = "CONTINUE_AS_NEW_INITIATOR_UNSPECIFIED",
  CONTINUE_AS_NEW_INITIATOR_WORKFLOW = "CONTINUE_AS_NEW_INITIATOR_WORKFLOW",
  CONTINUE_AS_NEW_INITIATOR_RETRY = "CONTINUE_AS_NEW_INITIATOR_RETRY",
  CONTINUE_AS_NEW_INITIATOR_CRON_SCHEDULE = "CONTINUE_AS_NEW_INITIATOR_CRON_SCHEDULE",
}

export interface V1ContinueAsNewWorkflowExecutionCommandAttributes {
  workflowType?: V1WorkflowType;
  taskQueue?: V1TaskQueue;
  input?: V1Payloads;
  /** Timeout of a single workflow run. */
  workflowRunTimeout?: string;
  /** Timeout of a single workflow task. */
  workflowTaskTimeout?: string;
  /** How long the workflow start will be delayed - not really a "backoff" in the traditional sense. */
  backoffStartInterval?: string;
  retryPolicy?: V1RetryPolicy;
  /** Should be removed */
  initiator?: V1ContinueAsNewInitiator;
  /** Should be removed */
  failure?: V1Failure;
  /** Should be removed */
  lastCompletionResult?: V1Payloads;
  /** Should be removed. Not necessarily unused but unclear and not exposed by SDKs. */
  cronSchedule?: string;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
  memo?: V1Memo;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
}

export interface V1CountWorkflowExecutionsResponse {
  /** @format int64 */
  count?: string;
}

export interface V1CreateScheduleResponse {
  /** @format byte */
  conflictToken?: string;
}

export interface V1DataBlob {
  encodingType?: V1EncodingType;
  /** @format byte */
  data?: string;
}

export type V1DeleteScheduleResponse = object;

/** Deprecated. */
export type V1DeprecateNamespaceResponse = object;

export interface V1DescribeBatchOperationResponse {
  /** Batch operation type */
  operationType?: V1BatchOperationType;
  /** Batch job ID */
  jobId?: string;
  /** Batch operation state */
  state?: V1BatchOperationState;
  /**
   * Batch operation start time
   * @format date-time
   */
  startTime?: string;
  /**
   * Batch operation close time
   * @format date-time
   */
  closeTime?: string;
  /**
   * Total operation count
   * @format int64
   */
  totalOperationCount?: string;
  /**
   * Complete operation count
   * @format int64
   */
  completeOperationCount?: string;
  /**
   * Failure operation count
   * @format int64
   */
  failureOperationCount?: string;
  /** Identity indicates the operator identity */
  identity?: string;
  /** Reason indicates the reason to stop a operation */
  reason?: string;
}

export interface V1DescribeNamespaceResponse {
  namespaceInfo?: V1NamespaceInfo;
  config?: V1NamespaceConfig;
  replicationConfig?: V1NamespaceReplicationConfig;
  /** @format int64 */
  failoverVersion?: string;
  isGlobalNamespace?: boolean;
  /**
   * Contains the historical state of failover_versions for the cluster, truncated to contain only the last N
   * states to ensure that the list does not grow unbounded.
   */
  failoverHistory?: V1FailoverStatus[];
}

export interface V1DescribeScheduleResponse {
  /**
   * The complete current schedule details. This may not match the schedule as
   * created because:
   * - some types of schedule specs may get compiled into others (e.g.
   *   CronString into StructuredCalendarSpec)
   * - some unspecified fields may be replaced by defaults
   * - some fields in the state are modified automatically
   * - the schedule may have been modified by UpdateSchedule or PatchSchedule
   */
  schedule?: V1Schedule;
  /** Extra schedule state info. */
  info?: V1ScheduleInfo;
  /** The memo and search attributes that the schedule was created with. */
  memo?: V1Memo;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
  /**
   * This value can be passed back to UpdateSchedule to ensure that the
   * schedule was not modified between a Describe and an Update, which could
   * lead to lost updates and other confusion.
   * @format byte
   */
  conflictToken?: string;
}

export interface V1DescribeTaskQueueResponse {
  pollers?: V1PollerInfo[];
  taskQueueStatus?: V1TaskQueueStatus;
}

export interface V1DescribeWorkflowExecutionResponse {
  executionConfig?: V1WorkflowExecutionConfig;
  workflowExecutionInfo?: V1WorkflowExecutionInfo;
  pendingActivities?: V1PendingActivityInfo[];
  pendingChildren?: V1PendingChildExecutionInfo[];
  pendingWorkflowTask?: V1PendingWorkflowTaskInfo;
}

/** @default "ENCODING_TYPE_UNSPECIFIED" */
export enum V1EncodingType {
  ENCODING_TYPE_UNSPECIFIED = "ENCODING_TYPE_UNSPECIFIED",
  ENCODINGTYPEPROTO3 = "ENCODING_TYPE_PROTO3",
  ENCODING_TYPE_JSON = "ENCODING_TYPE_JSON",
}

/**
 * Whenever this list of events is changed do change the function shouldBufferEvent in mutableStateBuilder.go to make sure to do the correct event ordering
 * - EVENT_TYPE_UNSPECIFIED: Place holder and should never appear in a Workflow execution history
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_STARTED: Workflow execution has been triggered/started
 * It contains Workflow execution inputs, as well as Workflow timeout configurations
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_COMPLETED: Workflow execution has successfully completed and contains Workflow execution results
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_FAILED: Workflow execution has unsuccessfully completed and contains the Workflow execution error
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_TIMED_OUT: Workflow execution has timed out by the Temporal Server
 * Usually due to the Workflow having not been completed within timeout settings
 *  - EVENT_TYPE_WORKFLOW_TASK_SCHEDULED: Workflow Task has been scheduled and the SDK client should now be able to process any new history events
 *  - EVENT_TYPE_WORKFLOW_TASK_STARTED: Workflow Task has started and the SDK client has picked up the Workflow Task and is processing new history events
 *  - EVENT_TYPE_WORKFLOW_TASK_COMPLETED: Workflow Task has completed
 * The SDK client picked up the Workflow Task and processed new history events
 * SDK client may or may not ask the Temporal Server to do additional work, such as:
 * EVENT_TYPE_ACTIVITY_TASK_SCHEDULED
 * EVENT_TYPE_TIMER_STARTED
 * EVENT_TYPE_UPSERT_WORKFLOW_SEARCH_ATTRIBUTES
 * EVENT_TYPE_MARKER_RECORDED
 * EVENT_TYPE_START_CHILD_WORKFLOW_EXECUTION_INITIATED
 * EVENT_TYPE_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED
 * EVENT_TYPE_SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED
 * EVENT_TYPE_WORKFLOW_EXECUTION_COMPLETED
 * EVENT_TYPE_WORKFLOW_EXECUTION_FAILED
 * EVENT_TYPE_WORKFLOW_EXECUTION_CANCELED
 * EVENT_TYPE_WORKFLOW_EXECUTION_CONTINUED_AS_NEW
 *  - EVENT_TYPE_WORKFLOW_TASK_TIMED_OUT: Workflow Task encountered a timeout
 * Either an SDK client with a local cache was not available at the time, or it took too long for the SDK client to process the task
 *  - EVENT_TYPE_WORKFLOW_TASK_FAILED: Workflow Task encountered a failure
 * Usually this means that the Workflow was non-deterministic
 * However, the Workflow reset functionality also uses this event
 *  - EVENT_TYPE_ACTIVITY_TASK_SCHEDULED: Activity Task was scheduled
 * The SDK client should pick up this activity task and execute
 * This event type contains activity inputs, as well as activity timeout configurations
 *  - EVENT_TYPE_ACTIVITY_TASK_STARTED: Activity Task has started executing
 * The SDK client has picked up the Activity Task and is processing the Activity invocation
 *  - EVENT_TYPE_ACTIVITY_TASK_COMPLETED: Activity Task has finished successfully
 * The SDK client has picked up and successfully completed the Activity Task
 * This event type contains Activity execution results
 *  - EVENT_TYPE_ACTIVITY_TASK_FAILED: Activity Task has finished unsuccessfully
 * The SDK picked up the Activity Task but unsuccessfully completed it
 * This event type contains Activity execution errors
 *  - EVENT_TYPE_ACTIVITY_TASK_TIMED_OUT: Activity has timed out according to the Temporal Server
 * Activity did not complete within the timeout settings
 *  - EVENT_TYPE_ACTIVITY_TASK_CANCEL_REQUESTED: A request to cancel the Activity has occurred
 * The SDK client will be able to confirm cancellation of an Activity during an Activity heartbeat
 *  - EVENT_TYPE_ACTIVITY_TASK_CANCELED: Activity has been cancelled
 *  - EVENT_TYPE_TIMER_STARTED: A timer has started
 *  - EVENT_TYPE_TIMER_FIRED: A timer has fired
 *  - EVENT_TYPE_TIMER_CANCELED: A time has been cancelled
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_CANCEL_REQUESTED: A request has been made to cancel the Workflow execution
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_CANCELED: SDK client has confirmed the cancellation request and the Workflow execution has been cancelled
 *  - EVENT_TYPE_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED: Workflow has requested that the Temporal Server try to cancel another Workflow
 *  - EVENT_TYPE_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_FAILED: Temporal Server could not cancel the targeted Workflow
 * This is usually because the target Workflow could not be found
 *  - EVENT_TYPE_EXTERNAL_WORKFLOW_EXECUTION_CANCEL_REQUESTED: Temporal Server has successfully requested the cancellation of the target Workflow
 *  - EVENT_TYPE_MARKER_RECORDED: A marker has been recorded.
 * This event type is transparent to the Temporal Server
 * The Server will only store it and will not try to understand it.
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_SIGNALED: Workflow has received a Signal event
 * The event type contains the Signal name, as well as a Signal payload
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_TERMINATED: Workflow execution has been forcefully terminated
 * This is usually because the terminate Workflow API was called
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_CONTINUED_AS_NEW: Workflow has successfully completed and a new Workflow has been started within the same transaction
 * Contains last Workflow execution results as well as new Workflow execution inputs
 *  - EVENT_TYPE_START_CHILD_WORKFLOW_EXECUTION_INITIATED: Temporal Server will try to start a child Workflow
 *  - EVENT_TYPE_START_CHILD_WORKFLOW_EXECUTION_FAILED: Child Workflow execution cannot be started/triggered
 * Usually due to a child Workflow ID collision
 *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_STARTED: Child Workflow execution has successfully started/triggered
 *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_COMPLETED: Child Workflow execution has successfully completed
 *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_FAILED: Child Workflow execution has unsuccessfully completed
 *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_CANCELED: Child Workflow execution has been cancelled
 *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_TIMED_OUT: Child Workflow execution has timed out by the Temporal Server
 *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_TERMINATED: Child Workflow execution has been terminated
 *  - EVENT_TYPE_SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED: Temporal Server will try to Signal the targeted Workflow
 * Contains the Signal name, as well as a Signal payload
 *  - EVENT_TYPE_SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_FAILED: Temporal Server cannot Signal the targeted Workflow
 * Usually because the Workflow could not be found
 *  - EVENT_TYPE_EXTERNAL_WORKFLOW_EXECUTION_SIGNALED: Temporal Server has successfully Signaled the targeted Workflow
 *  - EVENT_TYPE_UPSERT_WORKFLOW_SEARCH_ATTRIBUTES: Workflow search attributes should be updated and synchronized with the visibility store
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_UPDATE_ACCEPTED: An update was accepted (i.e. validated)
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_UPDATE_REJECTED: An update was rejected (i.e. failed validation)
 *  - EVENT_TYPE_WORKFLOW_EXECUTION_UPDATE_COMPLETED: An update completed
 *  - EVENT_TYPE_WORKFLOW_PROPERTIES_MODIFIED_EXTERNALLY: Some property or properties of the workflow as a whole have changed by non-workflow code.
 * The distinction of external vs. command-based modification is important so the SDK can
 * maintain determinism when using the command-based approach.
 *  - EVENT_TYPE_ACTIVITY_PROPERTIES_MODIFIED_EXTERNALLY: Some property or properties of an already-scheduled activity have changed by non-workflow code.
 * The distinction of external vs. command-based modification is important so the SDK can
 * maintain determinism when using the command-based approach.
 *  - EVENT_TYPE_WORKFLOW_PROPERTIES_MODIFIED: Workflow properties modified by user workflow code
 * @default "EVENT_TYPE_UNSPECIFIED"
 */
export enum V1EventType {
  UNSPECIFIED = "Unspecified Event",
  WORKFLOW_EXECUTION_STARTED = "WorkflowExecutionStarted",
  WORKFLOW_EXECUTION_COMPLETED = "WorkflowExecutionCompleted",
  WORKFLOW_EXECUTION_FAILED = "WorkflowExecutionFailed",
  WORKFLOW_EXECUTION_TIMED_OUT = "WorkflowExecutionTimed Out",
  WORKFLOW_TASK_SCHEDULED = "WorkflowTaskScheduled",
  WORKFLOW_TASK_STARTED = "WorkflowTaskStarted",
  WORKFLOW_TASK_COMPLETED = "WorkflowTaskCompleted",
  WORKFLOW_TASK_TIMED_OUT = "WorkflowTaskTimed Out",
  WORKFLOW_TASK_FAILED = "WorkflowTaskFailed",
  ACTIVITY_TASK_SCHEDULED = "ActivityTaskScheduled",
  ACTIVITY_TASK_STARTED = "ActivityTaskStarted",
  ACTIVITY_TASK_COMPLETED = "ActivityTaskCompleted",
  ACTIVITY_TASK_FAILED = "ActivityTaskFailed",
  ACTIVITY_TASK_TIMED_OUT = "ActivityTaskTimedOut",
  ACTIVITY_TASK_CANCEL_REQUESTED = "ActivityTaskCancelRequested",
  ACTIVITY_TASK_CANCELED = "ActivityTaskCanceled",
  TIMER_STARTED = "TimerStarted",
  TIMER_FIRED = "TimerFired",
  TIMER_CANCELED = "TimerCanceled",
  WORKFLOW_EXECUTION_CANCEL_REQUESTED = "WorkflowExecutionCancelRequested",
  WORKFLOW_EXECUTION_CANCELED = "WorkflowExecutionCanceled",
  REQUEST_CANCEL_EXTERNAL_WORKFLOW_INITIATED = "RequestCancelExternalWorkflowInitiated",
  REQUEST_CANCEL_EXTERNAL_WORKFLOW_FAILED = "RequestCancelExternalWorkflowFailed",
  EXTERNAL_WORKFLOW_CANCEL_REQUESTED = "ExternalWorkflowCancelRequested",
  MARKER_RECORDED = "MarkerRecorded",
  WORKFLOW_EXECUTION_SIGNALED = "WorkflowExecutionSignaled",
  WORKFLOW_EXECUTION_TERMINATED = "WorkflowExecutionTerminated",
  WORKFLOW_EXECUTION_CONTINUED_AS_NEW = "WorkflowExecutionContinuedAsNew",
  START_CHILD_WORKFLOW_INITIATED = "StartChildWorkflowInitiated",
  START_CHILD_WORKFLOW_FAILED = "StartChildWorkflowFailed",
  CHILD_WORKFLOW_STARTED = "ChildWorkflowStarted",
  CHILD_WORKFLOW_COMPLETED = "ChildWorkflowCompleted",
  CHILD_WORKFLOW_FAILED = "ChildWorkflowFailed",
  CHILD_WORKFLOW_CANCELED = "ChildWorkflowCanceled",
  CHILD_WORKFLOW_TIMED_OUT = "ChildWorkflowTimedOut",
  CHILD_WORKFLOW_TERMINATED = "ChildWorkflowTerminated",
  SIGNAL_EXTERNAL_WORKFLOW_INITIATED = "SignalExternalWorkflowInitiated",
  SIGNAL_EXTERNAL_WORKFLOW_FAILED = "SignalExternalWorkflowFailed",
  EXTERNAL_WORKFLOW_SIGNALED = "ExternalWorkflowSignaled",
  UPSERT_WORKFLOW_SEARCH_ATTRIBUTES = "UpsertWorkflowSearchAttributes",
  WORKFLOW_EXECUTION_UPDATE_ACCEPTED = "WorkflowExecutionUpdateAccepted",
  WORKFLOW_EXECUTION_UPDATE_REJECTED = "WorkflowExecutionUpdateRejected",
  WORKFLOW_EXECUTION_UPDATE_COMPLETED = "WorkflowExecutionUpdateCompleted",
  WORKFLOW_PROPERTIES_MODIFIED_EXTERNALLY = "WorkflowPropertiesModifiedExternally",
  ACTIVITY_PROPERTIES_MODIFIED_EXTERNALLY = "ActivityPropertiesModifiedExternally",
  WORKFLOW_PROPERTIES_MODIFIED = "WorkflowPropertiesModified",
}


export interface V1ExternalWorkflowExecutionCancelRequestedEventAttributes {
  /**
   * id of the `REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED` event this event corresponds
   * to
   * @format int64
   */
  initiatedEventId?: string;
  /**
   * Namespace of the to-be-cancelled workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
}

export interface V1ExternalWorkflowExecutionSignaledEventAttributes {
  /**
   * id of the `SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED` event this event corresponds to
   * @format int64
   */
  initiatedEventId?: string;
  /**
   * Namespace of the workflow which was signaled.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  /** Deprecated */
  control?: string;
}

export interface V1FailWorkflowExecutionCommandAttributes {
  failure?: V1Failure;
}

/** Represents a historical replication status of a Namespace */
export interface V1FailoverStatus {
  /**
   * Timestamp when the Cluster switched to the following failover_version
   * @format date-time
   */
  failoverTime?: string;
  /** @format int64 */
  failoverVersion?: string;
}

export interface V1Failure {
  message?: string;
  /**
   * The source this Failure originated in, e.g. TypeScriptSDK / JavaSDK
   * In some SDKs this is used to rehydrate the stack trace into an exception object.
   */
  source?: string;
  stackTrace?: string;
  /**
   * Alternative way to supply `message` and `stack_trace` and possibly other attributes, used for encryption of
   * errors originating in user code which might contain sensitive information.
   * The `encoded_attributes` Payload could represent any serializable object, e.g. JSON object or a `Failure` proto
   * message.
   *
   * SDK authors:
   * - The SDK should provide a default `encodeFailureAttributes` and `decodeFailureAttributes` implementation that:
   *   - Uses a JSON object to represent `{ message, stack_trace }`.
   *   - Overwrites the original message with "Encoded failure" to indicate that more information could be extracted.
   *   - Overwrites the original stack_trace with an empty string.
   *   - The resulting JSON object is converted to Payload using the default PayloadConverter and should be processed
   *     by the user-provided PayloadCodec
   *
   * - If there's demand, we could allow overriding the default SDK implementation to encode other opaque Failure attributes.
   * (-- api-linter: core::0203::optional=disabled --)
   */
  encodedAttributes?: V1Payload;
  cause?: V1Failure;
  applicationFailureInfo?: V1ApplicationFailureInfo;
  timeoutFailureInfo?: V1TimeoutFailureInfo;
  canceledFailureInfo?: V1CanceledFailureInfo;
  terminatedFailureInfo?: V1TerminatedFailureInfo;
  serverFailureInfo?: V1ServerFailureInfo;
  resetWorkflowFailureInfo?: V1ResetWorkflowFailureInfo;
  activityFailureInfo?: V1ActivityFailureInfo;
  childWorkflowExecutionFailureInfo?: V1ChildWorkflowExecutionFailureInfo;
}

/** GetClusterInfoResponse contains information about Temporal cluster. */
export interface V1GetClusterInfoResponse {
  /**
   * Key is client name i.e "temporal-go", "temporal-java", or "temporal-cli".
   * Value is ranges of supported versions of this client i.e ">1.1.1 <=1.4.0 || ^5.0.0".
   */
  supportedClients?: Record<string, string>;
  serverVersion?: string;
  clusterId?: string;
  /** VersionInfo contains details about current and recommended release versions as well as alerts and upgrade instructions. */
  versionInfo?: V1VersionInfo;
  clusterName?: string;
  /** @format int32 */
  historyShardCount?: number;
  persistenceStore?: string;
  visibilityStore?: string;
}

export interface V1GetSearchAttributesResponse {
  keys?: Record<string, V1IndexedValueType>;
}

export interface V1GetSystemInfoResponse {
  /** Version of the server. */
  serverVersion?: string;
  /** All capabilities the system supports. */
  capabilities?: GetSystemInfoResponseCapabilities;
}

export interface V1GetWorkflowExecutionHistoryResponse {
  history?: V1History;
  /**
   * Raw history is an alternate representation of history that may be returned if configured on
   * the frontend. This is not supported by all SDKs. Either this or `history` will be set.
   */
  rawHistory?: V1DataBlob[];
  /**
   * Will be set if there are more history events than were included in this response
   * @format byte
   */
  nextPageToken?: string;
  archived?: boolean;
}

export interface V1GetWorkflowExecutionHistoryReverseResponse {
  history?: V1History;
  /**
   * Will be set if there are more history events than were included in this response
   * @format byte
   */
  nextPageToken?: string;
}

/**
 * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
 * can be propagated between, for example, workflows and activities.
 */
export interface V1Header {
  fields?: Record<string, V1Payload>;
}

export interface V1History {
  events?: V1HistoryEvent[];
}

/**
 * History events are the method by which Temporal SDKs advance (or recreate) workflow state.
 * See the `EventType` enum for more info about what each event is for.
 */
export interface V1HistoryEvent {
  /**
   * Monotonically increasing event number, starts at 1.
   * @format int64
   */
  eventId?: string;
  /** @format date-time */
  eventTime?: string;
  /**
   * - EVENT_TYPE_UNSPECIFIED: Place holder and should never appear in a Workflow execution history
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_STARTED: Workflow execution has been triggered/started
   * It contains Workflow execution inputs, as well as Workflow timeout configurations
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_COMPLETED: Workflow execution has successfully completed and contains Workflow execution results
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_FAILED: Workflow execution has unsuccessfully completed and contains the Workflow execution error
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_TIMED_OUT: Workflow execution has timed out by the Temporal Server
   * Usually due to the Workflow having not been completed within timeout settings
   *  - EVENT_TYPE_WORKFLOW_TASK_SCHEDULED: Workflow Task has been scheduled and the SDK client should now be able to process any new history events
   *  - EVENT_TYPE_WORKFLOW_TASK_STARTED: Workflow Task has started and the SDK client has picked up the Workflow Task and is processing new history events
   *  - EVENT_TYPE_WORKFLOW_TASK_COMPLETED: Workflow Task has completed
   * The SDK client picked up the Workflow Task and processed new history events
   * SDK client may or may not ask the Temporal Server to do additional work, such as:
   * EVENT_TYPE_ACTIVITY_TASK_SCHEDULED
   * EVENT_TYPE_TIMER_STARTED
   * EVENT_TYPE_UPSERT_WORKFLOW_SEARCH_ATTRIBUTES
   * EVENT_TYPE_MARKER_RECORDED
   * EVENT_TYPE_START_CHILD_WORKFLOW_EXECUTION_INITIATED
   * EVENT_TYPE_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED
   * EVENT_TYPE_SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED
   * EVENT_TYPE_WORKFLOW_EXECUTION_COMPLETED
   * EVENT_TYPE_WORKFLOW_EXECUTION_FAILED
   * EVENT_TYPE_WORKFLOW_EXECUTION_CANCELED
   * EVENT_TYPE_WORKFLOW_EXECUTION_CONTINUED_AS_NEW
   *  - EVENT_TYPE_WORKFLOW_TASK_TIMED_OUT: Workflow Task encountered a timeout
   * Either an SDK client with a local cache was not available at the time, or it took too long for the SDK client to process the task
   *  - EVENT_TYPE_WORKFLOW_TASK_FAILED: Workflow Task encountered a failure
   * Usually this means that the Workflow was non-deterministic
   * However, the Workflow reset functionality also uses this event
   *  - EVENT_TYPE_ACTIVITY_TASK_SCHEDULED: Activity Task was scheduled
   * The SDK client should pick up this activity task and execute
   * This event type contains activity inputs, as well as activity timeout configurations
   *  - EVENT_TYPE_ACTIVITY_TASK_STARTED: Activity Task has started executing
   * The SDK client has picked up the Activity Task and is processing the Activity invocation
   *  - EVENT_TYPE_ACTIVITY_TASK_COMPLETED: Activity Task has finished successfully
   * The SDK client has picked up and successfully completed the Activity Task
   * This event type contains Activity execution results
   *  - EVENT_TYPE_ACTIVITY_TASK_FAILED: Activity Task has finished unsuccessfully
   * The SDK picked up the Activity Task but unsuccessfully completed it
   * This event type contains Activity execution errors
   *  - EVENT_TYPE_ACTIVITY_TASK_TIMED_OUT: Activity has timed out according to the Temporal Server
   * Activity did not complete within the timeout settings
   *  - EVENT_TYPE_ACTIVITY_TASK_CANCEL_REQUESTED: A request to cancel the Activity has occurred
   * The SDK client will be able to confirm cancellation of an Activity during an Activity heartbeat
   *  - EVENT_TYPE_ACTIVITY_TASK_CANCELED: Activity has been cancelled
   *  - EVENT_TYPE_TIMER_STARTED: A timer has started
   *  - EVENT_TYPE_TIMER_FIRED: A timer has fired
   *  - EVENT_TYPE_TIMER_CANCELED: A time has been cancelled
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_CANCEL_REQUESTED: A request has been made to cancel the Workflow execution
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_CANCELED: SDK client has confirmed the cancellation request and the Workflow execution has been cancelled
   *  - EVENT_TYPE_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED: Workflow has requested that the Temporal Server try to cancel another Workflow
   *  - EVENT_TYPE_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_FAILED: Temporal Server could not cancel the targeted Workflow
   * This is usually because the target Workflow could not be found
   *  - EVENT_TYPE_EXTERNAL_WORKFLOW_EXECUTION_CANCEL_REQUESTED: Temporal Server has successfully requested the cancellation of the target Workflow
   *  - EVENT_TYPE_MARKER_RECORDED: A marker has been recorded.
   * This event type is transparent to the Temporal Server
   * The Server will only store it and will not try to understand it.
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_SIGNALED: Workflow has received a Signal event
   * The event type contains the Signal name, as well as a Signal payload
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_TERMINATED: Workflow execution has been forcefully terminated
   * This is usually because the terminate Workflow API was called
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_CONTINUED_AS_NEW: Workflow has successfully completed and a new Workflow has been started within the same transaction
   * Contains last Workflow execution results as well as new Workflow execution inputs
   *  - EVENT_TYPE_START_CHILD_WORKFLOW_EXECUTION_INITIATED: Temporal Server will try to start a child Workflow
   *  - EVENT_TYPE_START_CHILD_WORKFLOW_EXECUTION_FAILED: Child Workflow execution cannot be started/triggered
   * Usually due to a child Workflow ID collision
   *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_STARTED: Child Workflow execution has successfully started/triggered
   *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_COMPLETED: Child Workflow execution has successfully completed
   *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_FAILED: Child Workflow execution has unsuccessfully completed
   *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_CANCELED: Child Workflow execution has been cancelled
   *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_TIMED_OUT: Child Workflow execution has timed out by the Temporal Server
   *  - EVENT_TYPE_CHILD_WORKFLOW_EXECUTION_TERMINATED: Child Workflow execution has been terminated
   *  - EVENT_TYPE_SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED: Temporal Server will try to Signal the targeted Workflow
   * Contains the Signal name, as well as a Signal payload
   *  - EVENT_TYPE_SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_FAILED: Temporal Server cannot Signal the targeted Workflow
   * Usually because the Workflow could not be found
   *  - EVENT_TYPE_EXTERNAL_WORKFLOW_EXECUTION_SIGNALED: Temporal Server has successfully Signaled the targeted Workflow
   *  - EVENT_TYPE_UPSERT_WORKFLOW_SEARCH_ATTRIBUTES: Workflow search attributes should be updated and synchronized with the visibility store
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_UPDATE_ACCEPTED: An update was accepted (i.e. validated)
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_UPDATE_REJECTED: An update was rejected (i.e. failed validation)
   *  - EVENT_TYPE_WORKFLOW_EXECUTION_UPDATE_COMPLETED: An update completed
   *  - EVENT_TYPE_WORKFLOW_PROPERTIES_MODIFIED_EXTERNALLY: Some property or properties of the workflow as a whole have changed by non-workflow code.
   * The distinction of external vs. command-based modification is important so the SDK can
   * maintain determinism when using the command-based approach.
   *  - EVENT_TYPE_ACTIVITY_PROPERTIES_MODIFIED_EXTERNALLY: Some property or properties of an already-scheduled activity have changed by non-workflow code.
   * The distinction of external vs. command-based modification is important so the SDK can
   * maintain determinism when using the command-based approach.
   *  - EVENT_TYPE_WORKFLOW_PROPERTIES_MODIFIED: Workflow properties modified by user workflow code
   */
  eventType?: V1EventType;
  /**
   * TODO: What is this? Appears unused by SDKs
   * @format int64
   */
  version?: string;
  /**
   * TODO: What is this? Appears unused by SDKs
   * @format int64
   */
  taskId?: string;
  /**
   * Set to true when the SDK may ignore the event as it does not impact workflow state or
   * information in any way that the SDK need be concerned with. If an SDK encounters an event
   * type which it does not understand, it must error unless this is true. If it is true, it's
   * acceptable for the event type and/or attributes to be uninterpretable.
   */
  workerMayIgnore?: boolean;
  workflowExecutionStartedEventAttributes?: V1WorkflowExecutionStartedEventAttributes;
  workflowExecutionCompletedEventAttributes?: V1WorkflowExecutionCompletedEventAttributes;
  workflowExecutionFailedEventAttributes?: V1WorkflowExecutionFailedEventAttributes;
  workflowExecutionTimedOutEventAttributes?: V1WorkflowExecutionTimedOutEventAttributes;
  workflowTaskScheduledEventAttributes?: V1WorkflowTaskScheduledEventAttributes;
  workflowTaskStartedEventAttributes?: V1WorkflowTaskStartedEventAttributes;
  workflowTaskCompletedEventAttributes?: V1WorkflowTaskCompletedEventAttributes;
  workflowTaskTimedOutEventAttributes?: V1WorkflowTaskTimedOutEventAttributes;
  workflowTaskFailedEventAttributes?: V1WorkflowTaskFailedEventAttributes;
  activityTaskScheduledEventAttributes?: V1ActivityTaskScheduledEventAttributes;
  activityTaskStartedEventAttributes?: V1ActivityTaskStartedEventAttributes;
  activityTaskCompletedEventAttributes?: V1ActivityTaskCompletedEventAttributes;
  activityTaskFailedEventAttributes?: V1ActivityTaskFailedEventAttributes;
  activityTaskTimedOutEventAttributes?: V1ActivityTaskTimedOutEventAttributes;
  timerStartedEventAttributes?: V1TimerStartedEventAttributes;
  timerFiredEventAttributes?: V1TimerFiredEventAttributes;
  activityTaskCancelRequestedEventAttributes?: V1ActivityTaskCancelRequestedEventAttributes;
  activityTaskCanceledEventAttributes?: V1ActivityTaskCanceledEventAttributes;
  timerCanceledEventAttributes?: V1TimerCanceledEventAttributes;
  markerRecordedEventAttributes?: V1MarkerRecordedEventAttributes;
  workflowExecutionSignaledEventAttributes?: V1WorkflowExecutionSignaledEventAttributes;
  workflowExecutionTerminatedEventAttributes?: V1WorkflowExecutionTerminatedEventAttributes;
  workflowExecutionCancelRequestedEventAttributes?: V1WorkflowExecutionCancelRequestedEventAttributes;
  workflowExecutionCanceledEventAttributes?: V1WorkflowExecutionCanceledEventAttributes;
  requestCancelExternalWorkflowExecutionInitiatedEventAttributes?: V1RequestCancelExternalWorkflowExecutionInitiatedEventAttributes;
  requestCancelExternalWorkflowExecutionFailedEventAttributes?: V1RequestCancelExternalWorkflowExecutionFailedEventAttributes;
  externalWorkflowExecutionCancelRequestedEventAttributes?: V1ExternalWorkflowExecutionCancelRequestedEventAttributes;
  workflowExecutionContinuedAsNewEventAttributes?: V1WorkflowExecutionContinuedAsNewEventAttributes;
  startChildWorkflowExecutionInitiatedEventAttributes?: V1StartChildWorkflowExecutionInitiatedEventAttributes;
  startChildWorkflowExecutionFailedEventAttributes?: V1StartChildWorkflowExecutionFailedEventAttributes;
  childWorkflowExecutionStartedEventAttributes?: V1ChildWorkflowExecutionStartedEventAttributes;
  childWorkflowExecutionCompletedEventAttributes?: V1ChildWorkflowExecutionCompletedEventAttributes;
  childWorkflowExecutionFailedEventAttributes?: V1ChildWorkflowExecutionFailedEventAttributes;
  childWorkflowExecutionCanceledEventAttributes?: V1ChildWorkflowExecutionCanceledEventAttributes;
  childWorkflowExecutionTimedOutEventAttributes?: V1ChildWorkflowExecutionTimedOutEventAttributes;
  childWorkflowExecutionTerminatedEventAttributes?: V1ChildWorkflowExecutionTerminatedEventAttributes;
  signalExternalWorkflowExecutionInitiatedEventAttributes?: V1SignalExternalWorkflowExecutionInitiatedEventAttributes;
  signalExternalWorkflowExecutionFailedEventAttributes?: V1SignalExternalWorkflowExecutionFailedEventAttributes;
  externalWorkflowExecutionSignaledEventAttributes?: V1ExternalWorkflowExecutionSignaledEventAttributes;
  upsertWorkflowSearchAttributesEventAttributes?: V1UpsertWorkflowSearchAttributesEventAttributes;
  workflowExecutionUpdateAcceptedEventAttributes?: V1WorkflowExecutionUpdateAcceptedEventAttributes;
  workflowExecutionUpdateRejectedEventAttributes?: V1WorkflowExecutionUpdateRejectedEventAttributes;
  workflowExecutionUpdateCompletedEventAttributes?: V1WorkflowExecutionUpdateCompletedEventAttributes;
  workflowPropertiesModifiedExternallyEventAttributes?: V1WorkflowPropertiesModifiedExternallyEventAttributes;
  activityPropertiesModifiedExternallyEventAttributes?: V1ActivityPropertiesModifiedExternallyEventAttributes;
  workflowPropertiesModifiedEventAttributes?: V1WorkflowPropertiesModifiedEventAttributes;
}

/** @default "HISTORY_EVENT_FILTER_TYPE_UNSPECIFIED" */
export enum V1HistoryEventFilterType {
  HISTORY_EVENT_FILTER_TYPE_UNSPECIFIED = "HISTORY_EVENT_FILTER_TYPE_UNSPECIFIED",
  HISTORY_EVENT_FILTER_TYPE_ALL_EVENT = "HISTORY_EVENT_FILTER_TYPE_ALL_EVENT",
  HISTORY_EVENT_FILTER_TYPE_CLOSE_EVENT = "HISTORY_EVENT_FILTER_TYPE_CLOSE_EVENT",
}

/** @default "INDEXED_VALUE_TYPE_UNSPECIFIED" */
export enum V1IndexedValueType {
  INDEXED_VALUE_TYPE_UNSPECIFIED = "INDEXED_VALUE_TYPE_UNSPECIFIED",
  INDEXED_VALUE_TYPE_TEXT = "INDEXED_VALUE_TYPE_TEXT",
  INDEXED_VALUE_TYPE_KEYWORD = "INDEXED_VALUE_TYPE_KEYWORD",
  INDEXED_VALUE_TYPE_INT = "INDEXED_VALUE_TYPE_INT",
  INDEXED_VALUE_TYPE_DOUBLE = "INDEXED_VALUE_TYPE_DOUBLE",
  INDEXED_VALUE_TYPE_BOOL = "INDEXED_VALUE_TYPE_BOOL",
  INDEXED_VALUE_TYPE_DATETIME = "INDEXED_VALUE_TYPE_DATETIME",
  INDEXED_VALUE_TYPE_KEYWORD_LIST = "INDEXED_VALUE_TYPE_KEYWORD_LIST",
}

export interface V1Input {
  /**
   * Headers that are passed with the update from the requesting entity.
   * These can include things like auth or tracing tokens.
   */
  header?: V1Header;
  /** The name of the input handler to invoke on the target workflow */
  name?: string;
  /** The arguments to pass to the named handler. */
  args?: V1Payloads;
}

/**
 * IntervalSpec matches times that can be expressed as:
 * epoch + n * interval + phase
 * where n is an integer.
 * phase defaults to zero if missing. interval is required.
 * Both interval and phase must be non-negative and are truncated to the nearest
 * second before any calculations.
 * For example, an interval of 1 hour with phase of zero would match every hour,
 * on the hour. The same interval but a phase of 19 minutes would match every
 * xx:19:00. An interval of 28 days with phase zero would match
 * 2022-02-17T00:00:00Z (among other times). The same interval with a phase of 3
 * days, 5 hours, and 23 minutes would match 2022-02-20T05:23:00Z instead.
 */
export interface V1IntervalSpec {
  interval?: string;
  phase?: string;
}

export interface V1ListArchivedWorkflowExecutionsResponse {
  executions?: V1WorkflowExecutionInfo[];
  /** @format byte */
  nextPageToken?: string;
}

export interface V1ListBatchOperationsResponse {
  /** BatchOperationInfo contains the basic info about batch operation */
  operationInfo?: V1BatchOperationInfo[];
  /** @format byte */
  nextPageToken?: string;
}

export interface V1ListClosedWorkflowExecutionsResponse {
  executions?: V1WorkflowExecutionInfo[];
  /** @format byte */
  nextPageToken?: string;
}

export interface V1ListNamespacesResponse {
  namespaces?: V1DescribeNamespaceResponse[];
  /** @format byte */
  nextPageToken?: string;
}

export interface V1ListOpenWorkflowExecutionsResponse {
  executions?: V1WorkflowExecutionInfo[];
  /** @format byte */
  nextPageToken?: string;
}

export interface V1ListScheduleMatchingTimesResponse {
  startTime?: string[];
}

export interface V1ListSchedulesResponse {
  schedules?: V1ScheduleListEntry[];
  /** @format byte */
  nextPageToken?: string;
}

export interface V1ListTaskQueuePartitionsResponse {
  activityTaskQueuePartitions?: V1TaskQueuePartitionMetadata[];
  workflowTaskQueuePartitions?: V1TaskQueuePartitionMetadata[];
}

export interface V1ListWorkflowExecutionsResponse {
  executions?: V1WorkflowExecutionInfo[];
  /** @format byte */
  nextPageToken?: string;
}

export interface V1MarkerRecordedEventAttributes {
  /** Workers use this to identify the "types" of various markers. Ex: Local activity, side effect. */
  markerName?: string;
  /** Serialized information recorded in the marker */
  details?: Record<string, V1Payloads>;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
  /** Some uses of markers, like a local activity, could "fail". If they did that is recorded here. */
  failure?: V1Failure;
}

/** A user-defined set of *unindexed* fields that are exposed when listing/searching workflows */
export interface V1Memo {
  fields?: Record<string, V1Payload>;
}

/**
 * (-- api-linter: core::0146::any=disabled
 *     aip.dev/not-precedent: We want runtime extensibility for the body field --)
 */
export interface V1Message {
  /** An ID for this specific message. */
  id?: string;
  /**
   * Identifies the specific instance of a protocol to which this message
   * belongs.
   */
  protocolInstanceId?: string;
  /** @format int64 */
  eventId?: string;
  /** @format int64 */
  commandIndex?: string;
  /**
   * The opaque data carried by this message. The protocol type can be
   * extracted from the package name of the message carried inside the Any.
   */
  body?: ProtobufAny;
}

/** Metadata about a workflow execution update. */
export interface V1Meta {
  /** An ID with workflow-scoped uniqueness for this update */
  updateId?: string;
  /** A string identifying the agent that requested this update. */
  identity?: string;
}

export interface V1ModifyWorkflowPropertiesCommandAttributes {
  /**
   * If set, update the workflow memo with the provided values. The values will be merged with
   * the existing memo. If the user wants to delete values, a default/empty Payload should be
   * used as the value for the key being deleted.
   */
  upsertedMemo?: V1Memo;
}

export interface V1NamespaceConfig {
  workflowExecutionRetentionTtl?: string;
  badBinaries?: V1BadBinaries;
  /** If unspecified (ARCHIVAL_STATE_UNSPECIFIED) then default server configuration is used. */
  historyArchivalState?: V1ArchivalState;
  historyArchivalUri?: string;
  /** If unspecified (ARCHIVAL_STATE_UNSPECIFIED) then default server configuration is used. */
  visibilityArchivalState?: V1ArchivalState;
  visibilityArchivalUri?: string;
  /** Map from field name to alias. */
  customSearchAttributeAliases?: Record<string, string>;
}

export interface V1NamespaceFilter {
  /**
   * By default namespaces in NAMESPACE_STATE_DELETED state are not included.
   * Setting include_deleted to true will include deleted namespaces.
   * Note: Namespace is in NAMESPACE_STATE_DELETED state when it was deleted from the system but associated data is not deleted yet.
   */
  includeDeleted?: boolean;
}

export interface V1NamespaceInfo {
  name?: string;
  state?: V1NamespaceState;
  description?: string;
  ownerEmail?: string;
  /** A key-value map for any customized purpose. */
  data?: Record<string, string>;
  id?: string;
  /**
   * Whether scheduled workflows are supported on this namespace. This is only needed
   * temporarily while the feature is experimental, so we can give it a high tag.
   */
  supportsSchedules?: boolean;
}

export interface V1NamespaceReplicationConfig {
  activeClusterName?: string;
  clusters?: V1ClusterReplicationConfig[];
  state?: V1ReplicationState;
}

/** @default "NAMESPACE_STATE_UNSPECIFIED" */
export enum V1NamespaceState {
  NAMESPACE_STATE_UNSPECIFIED = "NAMESPACE_STATE_UNSPECIFIED",
  NAMESPACE_STATE_REGISTERED = "NAMESPACE_STATE_REGISTERED",
  NAMESPACE_STATE_DEPRECATED = "NAMESPACE_STATE_DEPRECATED",
  NAMESPACE_STATE_DELETED = "NAMESPACE_STATE_DELETED",
}

/**
 * NewWorkflowExecutionInfo is a shared message that encapsulates all the
 * required arguments to starting a workflow in different contexts.
 */
export interface V1NewWorkflowExecutionInfo {
  workflowId?: string;
  workflowType?: V1WorkflowType;
  taskQueue?: V1TaskQueue;
  /** Serialized arguments to the workflow. */
  input?: V1Payloads;
  /** Total workflow execution timeout including retries and continue as new. */
  workflowExecutionTimeout?: string;
  /** Timeout of a single workflow run. */
  workflowRunTimeout?: string;
  /** Timeout of a single workflow task. */
  workflowTaskTimeout?: string;
  /** Default: WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE. */
  workflowIdReusePolicy?: V1WorkflowIdReusePolicy;
  /** The retry policy for the workflow. Will never exceed `workflow_execution_timeout`. */
  retryPolicy?: V1RetryPolicy;
  /** See https://docs.temporal.io/docs/content/what-is-a-temporal-cron-job/ */
  cronSchedule?: string;
  memo?: V1Memo;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
}

/** The outcome of a workflow update - success or failure. */
export interface V1Outcome {
  success?: V1Payloads;
  failure?: V1Failure;
}

/**
 * Defines how child workflows will react to their parent completing
 * - PARENT_CLOSE_POLICY_TERMINATE: The child workflow will also terminate
 *  - PARENT_CLOSE_POLICY_ABANDON: The child workflow will do nothing
 *  - PARENT_CLOSE_POLICY_REQUEST_CANCEL: Cancellation will be requested of the child workflow
 * @default "PARENT_CLOSE_POLICY_UNSPECIFIED"
 */
export enum V1ParentClosePolicy {
  PARENT_CLOSE_POLICY_UNSPECIFIED = "PARENT_CLOSE_POLICY_UNSPECIFIED",
  PARENT_CLOSE_POLICY_TERMINATE = "PARENT_CLOSE_POLICY_TERMINATE",
  PARENT_CLOSE_POLICY_ABANDON = "PARENT_CLOSE_POLICY_ABANDON",
  PARENT_CLOSE_POLICY_REQUEST_CANCEL = "PARENT_CLOSE_POLICY_REQUEST_CANCEL",
}

export type V1PatchScheduleResponse = object;

/**
 * Represents some binary (byte array) data (ex: activity input parameters or workflow result) with
 * metadata which describes this binary data (format, encoding, encryption, etc). Serialization
 * of the data may be user-defined.
 */
export interface V1Payload {
  metadata?: Record<string, string>;
  /** @format byte */
  data?: string;
}

/** See `Payload` */
export interface V1Payloads {
  payloads?: V1Payload[];
}

export interface V1PendingActivityInfo {
  activityId?: string;
  activityType?: V1ActivityType;
  state?: V1PendingActivityState;
  heartbeatDetails?: V1Payloads;
  /** @format date-time */
  lastHeartbeatTime?: string;
  /** @format date-time */
  lastStartedTime?: string;
  /** @format int32 */
  attempt?: number;
  /** @format int32 */
  maximumAttempts?: number;
  /** @format date-time */
  scheduledTime?: string;
  /** @format date-time */
  expirationTime?: string;
  lastFailure?: V1Failure;
  lastWorkerIdentity?: string;
}

/** @default "PENDING_ACTIVITY_STATE_UNSPECIFIED" */
export enum V1PendingActivityState {
  PENDING_ACTIVITY_STATE_UNSPECIFIED = "PENDING_ACTIVITY_STATE_UNSPECIFIED",
  PENDING_ACTIVITY_STATE_SCHEDULED = "PENDING_ACTIVITY_STATE_SCHEDULED",
  PENDING_ACTIVITY_STATE_STARTED = "PENDING_ACTIVITY_STATE_STARTED",
  PENDING_ACTIVITY_STATE_CANCEL_REQUESTED = "PENDING_ACTIVITY_STATE_CANCEL_REQUESTED",
}

export interface V1PendingChildExecutionInfo {
  workflowId?: string;
  runId?: string;
  workflowTypeName?: string;
  /** @format int64 */
  initiatedId?: string;
  /** Default: PARENT_CLOSE_POLICY_TERMINATE. */
  parentClosePolicy?: V1ParentClosePolicy;
}

export interface V1PendingWorkflowTaskInfo {
  state?: V1PendingWorkflowTaskState;
  /** @format date-time */
  scheduledTime?: string;
  /**
   * original_scheduled_time is the scheduled time of the first workflow task during workflow task heartbeat.
   * Heartbeat workflow task is done by RespondWorkflowTaskComplete with ForceCreateNewWorkflowTask == true and no command
   * In this case, OriginalScheduledTime won't change. Then when current time - original_scheduled_time exceeds
   * some threshold, the workflow task will be forced timeout.
   * @format date-time
   */
  originalScheduledTime?: string;
  /** @format date-time */
  startedTime?: string;
  /** @format int32 */
  attempt?: number;
}

/** @default "PENDING_WORKFLOW_TASK_STATE_UNSPECIFIED" */
export enum V1PendingWorkflowTaskState {
  PENDING_WORKFLOW_TASK_STATE_UNSPECIFIED = "PENDING_WORKFLOW_TASK_STATE_UNSPECIFIED",
  PENDING_WORKFLOW_TASK_STATE_SCHEDULED = "PENDING_WORKFLOW_TASK_STATE_SCHEDULED",
  PENDING_WORKFLOW_TASK_STATE_STARTED = "PENDING_WORKFLOW_TASK_STATE_STARTED",
}

export interface V1PollActivityTaskQueueResponse {
  /**
   * A unique identifier for this task
   * @format byte
   */
  taskToken?: string;
  /** The namespace the workflow which requested this activity lives in */
  workflowNamespace?: string;
  /** Type of the requesting workflow */
  workflowType?: V1WorkflowType;
  /**
   * Execution info of the requesting workflow
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  activityType?: V1ActivityType;
  /**
   * The autogenerated or user specified identifier of this activity. Can be used to complete the
   * activity via `RespondActivityTaskCompletedById`. May be re-used as long as the last usage
   * has resolved, but unique IDs for every activity invocation is a good idea.
   */
  activityId?: string;
  /**
   * Headers specified by the scheduling workflow. Commonly used to propagate contextual info
   * from the workflow to its activities. For example, tracing contexts.
   */
  header?: V1Header;
  /** Arguments to the activity invocation */
  input?: V1Payloads;
  /**
   * Details of the last heartbeat that was recorded for this activity as of the time this task
   * was delivered.
   */
  heartbeatDetails?: V1Payloads;
  /**
   * When was this task first scheduled
   * @format date-time
   */
  scheduledTime?: string;
  /**
   * When was this task attempt scheduled
   * @format date-time
   */
  currentAttemptScheduledTime?: string;
  /**
   * When was this task started (this attempt)
   * @format date-time
   */
  startedTime?: string;
  /**
   * Starting at 1, the number of attempts to perform this activity
   * @format int32
   */
  attempt?: number;
  /**
   * First scheduled -> final result reported timeout
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  scheduleToCloseTimeout?: string;
  /**
   * Current attempt start -> final result reported timeout
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  startToCloseTimeout?: string;
  /** Window within which the activity must report a heartbeat, or be timed out. */
  heartbeatTimeout?: string;
  /**
   * This is the retry policy the service uses which may be different from the one provided
   * (or not) during activity scheduling. The service can override the provided one if some
   * values are not specified or exceed configured system limits.
   */
  retryPolicy?: V1RetryPolicy;
}

export interface V1PollWorkflowTaskQueueResponse {
  /**
   * A unique identifier for this task
   * @format byte
   */
  taskToken?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  workflowType?: V1WorkflowType;
  /**
   * The last workflow task started event which was processed by some worker for this execution.
   * Will be zero if no task has ever started.
   * @format int64
   */
  previousStartedEventId?: string;
  /**
   * The id of the most recent workflow task started event, which will have been generated as a
   * result of this poll request being served.
   * @format int64
   */
  startedEventId?: string;
  /**
   * Starting at 1, the number of attempts to complete this task by any worker.
   * @format int32
   */
  attempt?: number;
  /**
   * A hint that there are more tasks already present in this task queue. Can be used to
   * prioritize draining a sticky queue before polling from a normal queue.
   * @format int64
   */
  backlogCountHint?: string;
  /**
   * The history for this workflow, which will either be complete or partial. Partial histories
   * are sent to workers who have signaled that they are using a sticky queue when completing
   * a workflow task.
   */
  history?: V1History;
  /**
   * Will be set if there are more history events than were included in this response. Such events
   * should be fetched via `GetWorkflowExecutionHistory`.
   * @format byte
   */
  nextPageToken?: string;
  /**
   * Legacy queries appear in this field. The query must be responded to via
   * `RespondQueryTaskCompleted`. If the workflow is already closed (queries are permitted on
   * closed workflows) then the `history` field will be populated with the entire history. It
   * may also be populated if this task originates on a non-sticky queue.
   */
  query?: V1WorkflowQuery;
  /**
   * The task queue this task originated from, which will always be the original non-sticky name
   * for the queue, even if this response came from polling a sticky queue.
   */
  workflowExecutionTaskQueue?: V1TaskQueue;
  /**
   * When this task was scheduled by the server
   * @format date-time
   */
  scheduledTime?: string;
  /**
   * When the current workflow task started event was generated, meaning the current attempt.
   * @format date-time
   */
  startedTime?: string;
  /**
   * Queries that should be executed after applying the history in this task. Responses should be
   * attached to `RespondWorkflowTaskCompletedRequest::query_results`
   */
  queries?: Record<string, V1WorkflowQuery>;
  /** Protocol messages piggybacking on a WFT as a transport */
  messages?: V1Message[];
}

export interface V1PollerInfo {
  /**
   * Unix Nano
   * @format date-time
   */
  lastAccessTime?: string;
  identity?: string;
  /** @format double */
  ratePerSecond?: number;
  /**
   * If a worker has specified an ID for use with the worker versioning feature while polling,
   * that id must appear here.
   */
  workerVersioningId?: V1VersionId;
}

export interface V1ProtocolMessageCommandAttributes {
  /** The message ID of the message to which this command is a pointer. */
  messageId?: string;
}

/**
 *  - QUERY_REJECT_CONDITION_NONE: None indicates that query should not be rejected.
 *  - QUERY_REJECT_CONDITION_NOT_OPEN: NotOpen indicates that query should be rejected if workflow is not open.
 *  - QUERY_REJECT_CONDITION_NOT_COMPLETED_CLEANLY: NotCompletedCleanly indicates that query should be rejected if workflow did not complete cleanly.
 * @default "QUERY_REJECT_CONDITION_UNSPECIFIED"
 */
export enum V1QueryRejectCondition {
  QUERY_REJECT_CONDITION_UNSPECIFIED = "QUERY_REJECT_CONDITION_UNSPECIFIED",
  QUERY_REJECT_CONDITION_NONE = "QUERY_REJECT_CONDITION_NONE",
  QUERY_REJECT_CONDITION_NOT_OPEN = "QUERY_REJECT_CONDITION_NOT_OPEN",
  QUERY_REJECT_CONDITION_NOT_COMPLETED_CLEANLY = "QUERY_REJECT_CONDITION_NOT_COMPLETED_CLEANLY",
}

export interface V1QueryRejected {
  /** - WORKFLOW_EXECUTION_STATUS_RUNNING: Value 1 is hardcoded in SQL persistence. */
  status?: V1WorkflowExecutionStatus;
}

/** @default "QUERY_RESULT_TYPE_UNSPECIFIED" */
export enum V1QueryResultType {
  QUERY_RESULT_TYPE_UNSPECIFIED = "QUERY_RESULT_TYPE_UNSPECIFIED",
  QUERY_RESULT_TYPE_ANSWERED = "QUERY_RESULT_TYPE_ANSWERED",
  QUERY_RESULT_TYPE_FAILED = "QUERY_RESULT_TYPE_FAILED",
}

export interface V1QueryWorkflowResponse {
  queryResult?: V1Payloads;
  queryRejected?: V1QueryRejected;
}

/**
 * Range represents a set of integer values, used to match fields of a calendar
 * time in StructuredCalendarSpec. If end < start, then end is interpreted as
 * equal to start. This means you can use a Range with start set to a value, and
 * end and step unset (defaulting to 0) to represent a single value.
 */
export interface V1Range {
  /**
   * Start of range (inclusive).
   * @format int32
   */
  start?: number;
  /**
   * End of range (inclusive).
   * @format int32
   */
  end?: number;
  /**
   * Step (optional, default 1).
   * @format int32
   */
  step?: number;
}

export interface V1RecordActivityTaskHeartbeatByIdResponse {
  /**
   * Will be set to true if the activity has been asked to cancel itself. The SDK should then
   * notify the activity of cancellation if it is still running.
   */
  cancelRequested?: boolean;
}

export interface V1RecordActivityTaskHeartbeatResponse {
  /**
   * Will be set to true if the activity has been asked to cancel itself. The SDK should then
   * notify the activity of cancellation if it is still running.
   */
  cancelRequested?: boolean;
}

export interface V1RecordMarkerCommandAttributes {
  markerName?: string;
  details?: Record<string, V1Payloads>;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
  failure?: V1Failure;
}

export interface V1RegisterNamespaceRequest {
  namespace?: string;
  description?: string;
  ownerEmail?: string;
  workflowExecutionRetentionPeriod?: string;
  clusters?: V1ClusterReplicationConfig[];
  activeClusterName?: string;
  /** A key-value map for any customized purpose. */
  data?: Record<string, string>;
  securityToken?: string;
  isGlobalNamespace?: boolean;
  /** If unspecified (ARCHIVAL_STATE_UNSPECIFIED) then default server configuration is used. */
  historyArchivalState?: V1ArchivalState;
  historyArchivalUri?: string;
  /** If unspecified (ARCHIVAL_STATE_UNSPECIFIED) then default server configuration is used. */
  visibilityArchivalState?: V1ArchivalState;
  visibilityArchivalUri?: string;
}

export type V1RegisterNamespaceResponse = object;

/** ReleaseInfo contains information about specific version of temporal. */
export interface V1ReleaseInfo {
  version?: string;
  /** @format date-time */
  releaseTime?: string;
  notes?: string;
}

/** @default "REPLICATION_STATE_UNSPECIFIED" */
export enum V1ReplicationState {
  REPLICATION_STATE_UNSPECIFIED = "REPLICATION_STATE_UNSPECIFIED",
  REPLICATION_STATE_NORMAL = "REPLICATION_STATE_NORMAL",
  REPLICATION_STATE_HANDOVER = "REPLICATION_STATE_HANDOVER",
}

/** The client request that triggers a workflow execution update */
export interface V1Request {
  /** Metadata about a workflow execution update. */
  meta?: V1Meta;
  input?: V1Input;
}

export interface V1RequestCancelActivityTaskCommandAttributes {
  /**
   * The `ACTIVITY_TASK_SCHEDULED` event id for the activity being cancelled.
   * @format int64
   */
  scheduledEventId?: string;
}

export interface V1RequestCancelExternalWorkflowExecutionCommandAttributes {
  namespace?: string;
  workflowId?: string;
  runId?: string;
  /** Deprecated. */
  control?: string;
  /**
   * Set this to true if the workflow being cancelled is a child of the workflow originating this
   * command. The request will be rejected if it is set to true and the target workflow is *not*
   * a child of the requesting workflow.
   */
  childWorkflowOnly?: boolean;
  /** Reason for requesting the cancellation */
  reason?: string;
}

export interface V1RequestCancelExternalWorkflowExecutionFailedEventAttributes {
  cause?: V1CancelExternalWorkflowExecutionFailedCause;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /**
   * Namespace of the workflow which failed to cancel.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  /**
   * id of the `REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_INITIATED` event this failure
   * corresponds to
   * @format int64
   */
  initiatedEventId?: string;
  /** Deprecated */
  control?: string;
}

export interface V1RequestCancelExternalWorkflowExecutionInitiatedEventAttributes {
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /**
   * The namespace the workflow to be cancelled lives in.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  /** Deprecated */
  control?: string;
  /**
   * Workers are expected to set this to true if the workflow they are requesting to cancel is
   * a child of the workflow which issued the request
   */
  childWorkflowOnly?: boolean;
  /** Reason for requesting the cancellation */
  reason?: string;
}

export type V1RequestCancelWorkflowExecutionResponse = object;

export interface V1ResetPointInfo {
  binaryChecksum?: string;
  runId?: string;
  /** @format int64 */
  firstWorkflowTaskCompletedId?: string;
  /** @format date-time */
  createTime?: string;
  /**
   * (-- api-linter: core::0214::resource-expiry=disabled
   *     aip.dev/not-precedent: TTL is not defined for ResetPointInfo. --)
   * The time that the run is deleted due to retention.
   * @format date-time
   */
  expireTime?: string;
  /** false if the reset point has pending childWFs/reqCancels/signalExternals. */
  resettable?: boolean;
}

export interface V1ResetPoints {
  points?: V1ResetPointInfo[];
}

/**
 * Reset reapplay(replay) options
 * * RESET_REAPPLY_TYPE_SIGNAL (default) - Signals are reapplied when workflow is reset
 * * RESET_REAPPLY_TYPE_NONE - nothing is reapplied
 * @default "RESET_REAPPLY_TYPE_UNSPECIFIED"
 */
export enum V1ResetReapplyType {
  RESET_REAPPLY_TYPE_UNSPECIFIED = "RESET_REAPPLY_TYPE_UNSPECIFIED",
  RESET_REAPPLY_TYPE_SIGNAL = "RESET_REAPPLY_TYPE_SIGNAL",
  RESET_REAPPLY_TYPE_NONE = "RESET_REAPPLY_TYPE_NONE",
}

export type V1ResetStickyTaskQueueResponse = object;

export interface V1ResetWorkflowExecutionResponse {
  runId?: string;
}

export interface V1ResetWorkflowFailureInfo {
  lastHeartbeatDetails?: V1Payloads;
}

export type V1RespondActivityTaskCanceledByIdResponse = object;

export type V1RespondActivityTaskCanceledResponse = object;

export type V1RespondActivityTaskCompletedByIdResponse = object;

export type V1RespondActivityTaskCompletedResponse = object;

export interface V1RespondActivityTaskFailedByIdResponse {
  /**
   * Server validation failures could include
   * last_heartbeat_details payload is too large, request failure is too large
   */
  failures?: V1Failure[];
}

export interface V1RespondActivityTaskFailedResponse {
  /**
   * Server validation failures could include
   * last_heartbeat_details payload is too large, request failure is too large
   */
  failures?: V1Failure[];
}

export type V1RespondQueryTaskCompletedResponse = object;

export interface V1RespondWorkflowTaskCompletedResponse {
  /** See `RespondWorkflowTaskCompletedResponse::return_new_workflow_task` */
  workflowTask?: V1PollWorkflowTaskQueueResponse;
  /** See `ScheduleActivityTaskCommandAttributes::request_start` */
  activityTasks?: V1PollActivityTaskQueueResponse[];
  /** @format int64 */
  resetHistoryEventId?: string;
}

export type V1RespondWorkflowTaskFailedResponse = object;

/** How retries ought to be handled, usable by both workflows and activities */
export interface V1RetryPolicy {
  /** Interval of the first retry. If retryBackoffCoefficient is 1.0 then it is used for all retries. */
  initialInterval?: string;
  /**
   * Coefficient used to calculate the next retry interval.
   * The next retry interval is previous interval multiplied by the coefficient.
   * Must be 1 or larger.
   * @format double
   */
  backoffCoefficient?: number;
  /**
   * Maximum interval between retries. Exponential backoff leads to interval increase.
   * This value is the cap of the increase. Default is 100x of the initial interval.
   */
  maximumInterval?: string;
  /**
   * Maximum number of attempts. When exceeded the retries stop even if not expired yet.
   * 1 disables retries. 0 means unlimited (up to the timeouts)
   * @format int32
   */
  maximumAttempts?: number;
  /**
   * Non-Retryable errors types. Will stop retrying if the error type matches this list. Note that
   * this is not a substring match, the error *type* (not message) must match exactly.
   */
  nonRetryableErrorTypes?: string[];
}

/** @default "RETRY_STATE_UNSPECIFIED" */
export enum V1RetryState {
  RETRY_STATE_UNSPECIFIED = "RETRY_STATE_UNSPECIFIED",
  RETRY_STATE_IN_PROGRESS = "RETRY_STATE_IN_PROGRESS",
  RETRY_STATE_NON_RETRYABLE_FAILURE = "RETRY_STATE_NON_RETRYABLE_FAILURE",
  RETRY_STATE_TIMEOUT = "RETRY_STATE_TIMEOUT",
  RETRY_STATE_MAXIMUM_ATTEMPTS_REACHED = "RETRY_STATE_MAXIMUM_ATTEMPTS_REACHED",
  RETRY_STATE_RETRY_POLICY_NOT_SET = "RETRY_STATE_RETRY_POLICY_NOT_SET",
  RETRY_STATE_INTERNAL_SERVER_ERROR = "RETRY_STATE_INTERNAL_SERVER_ERROR",
  RETRY_STATE_CANCEL_REQUESTED = "RETRY_STATE_CANCEL_REQUESTED",
}

export interface V1ScanWorkflowExecutionsResponse {
  executions?: V1WorkflowExecutionInfo[];
  /** @format byte */
  nextPageToken?: string;
}

export interface V1Schedule {
  /**
   * ScheduleSpec is a complete description of a set of absolute timestamps
   * (possibly infinite) that an action should occur at. The meaning of a
   * ScheduleSpec depends only on its contents and never changes, except that the
   * definition of a time zone can change over time (most commonly, when daylight
   * saving time policy changes for an area). To create a totally self-contained
   * ScheduleSpec, use UTC or include timezone_data.
   *
   * For input, you can provide zero or more of: structured_calendar, calendar,
   * cron_string, interval, and exclude_structured_calendar, and all of them will
   * be used (the schedule will take action at the union of all of their times,
   * minus the ones that match exclude_structured_calendar).
   *
   * On input, calendar and cron_string fields will be compiled into
   * structured_calendar (and maybe interval and timezone_name), so if you
   * Describe a schedule, you'll see only structured_calendar, interval, etc.
   */
  spec?: V1ScheduleSpec;
  action?: V1ScheduleAction;
  policies?: V1SchedulePolicies;
  state?: V1ScheduleState;
}

export interface V1ScheduleAction {
  /**
   * All fields of NewWorkflowExecutionInfo are valid except for:
   * - workflow_id_reuse_policy
   * - cron_schedule
   * The workflow id of the started workflow may not match this exactly,
   * it may have a timestamp appended for uniqueness.
   */
  startWorkflow?: V1NewWorkflowExecutionInfo;
}

export interface V1ScheduleActionResult {
  /**
   * Time that the action was taken (according to the schedule, including jitter).
   * @format date-time
   */
  scheduleTime?: string;
  /**
   * Time that the action was taken (real time).
   * @format date-time
   */
  actualTime?: string;
  /**
   * If action was start_workflow:
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  startWorkflowResult?: V1WorkflowExecution;
}

export interface V1ScheduleActivityTaskCommandAttributes {
  activityId?: string;
  activityType?: V1ActivityType;
  taskQueue?: V1TaskQueue;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
  input?: V1Payloads;
  /**
   * Indicates how long the caller is willing to wait for activity completion. The "schedule" time
   * is when the activity is initially scheduled, not when the most recent retry is scheduled.
   * Limits how long retries will be attempted. Either this or `start_to_close_timeout` must be
   * specified. When not specified, defaults to the workflow execution timeout.
   *
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  scheduleToCloseTimeout?: string;
  /**
   * Limits the time an activity task can stay in a task queue before a worker picks it up. The
   * "schedule" time is when the most recent retry is scheduled. This timeout should usually not
   * be set: it's useful in specific scenarios like worker-specific task queues. This timeout is
   * always non retryable, as all a retry would achieve is to put it back into the same queue.
   * Defaults to `schedule_to_close_timeout` or workflow execution timeout if that is not
   * specified. More info:
   * https://docs.temporal.io/docs/content/what-is-a-schedule-to-start-timeout/
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  scheduleToStartTimeout?: string;
  /**
   * Maximum time an activity is allowed to execute after being picked up by a worker. This
   * timeout is always retryable. Either this or `schedule_to_close_timeout` must be specified.
   *
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  startToCloseTimeout?: string;
  /** Maximum permitted time between successful worker heartbeats. */
  heartbeatTimeout?: string;
  /**
   * Activities are provided by a default retry policy which is controlled through the service's
   * dynamic configuration. Retries will be attempted until `schedule_to_close_timeout` has
   * elapsed. To disable retries set retry_policy.maximum_attempts to 1.
   */
  retryPolicy?: V1RetryPolicy;
  /**
   * Request to start the activity directly bypassing matching service and worker polling
   * The slot for executing the activity should be reserved when setting this field to true.
   */
  requestEagerExecution?: boolean;
}

export interface V1ScheduleInfo {
  /**
   * Number of actions taken so far.
   * @format int64
   */
  actionCount?: string;
  /**
   * Number of times a scheduled action was skipped due to missing the catchup window.
   * @format int64
   */
  missedCatchupWindow?: string;
  /**
   * Number of skipped actions due to overlap.
   * @format int64
   */
  overlapSkipped?: string;
  /**
   * Currently-running workflows started by this schedule. (There might be
   * more than one if the overlap policy allows overlaps.)
   * Note that the run_ids in here are the original execution run ids as
   * started by the schedule. If the workflows retried, did continue-as-new,
   * or were reset, they might still be running but with a different run_id.
   */
  runningWorkflows?: V1WorkflowExecution[];
  /** Most recent ten actual action times (including manual triggers). */
  recentActions?: V1ScheduleActionResult[];
  /** Next ten scheduled action times. */
  futureActionTimes?: string[];
  /**
   * Timestamps of schedule creation and last update.
   * @format date-time
   */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
  invalidScheduleError?: string;
}

/** ScheduleListEntry is returned by ListSchedules. */
export interface V1ScheduleListEntry {
  scheduleId?: string;
  memo?: V1Memo;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
  /**
   * ScheduleListInfo is an abbreviated set of values from Schedule and ScheduleInfo
   * that's returned in ListSchedules.
   */
  info?: V1ScheduleListInfo;
}

/**
 * ScheduleListInfo is an abbreviated set of values from Schedule and ScheduleInfo
 * that's returned in ListSchedules.
 */
export interface V1ScheduleListInfo {
  /**
   * From spec:
   * Some fields are dropped from this copy of spec: timezone_data
   * ScheduleSpec is a complete description of a set of absolute timestamps
   * (possibly infinite) that an action should occur at. The meaning of a
   * ScheduleSpec depends only on its contents and never changes, except that the
   * definition of a time zone can change over time (most commonly, when daylight
   * saving time policy changes for an area). To create a totally self-contained
   * ScheduleSpec, use UTC or include timezone_data.
   *
   * For input, you can provide zero or more of: structured_calendar, calendar,
   * cron_string, interval, and exclude_structured_calendar, and all of them will
   * be used (the schedule will take action at the union of all of their times,
   * minus the ones that match exclude_structured_calendar).
   *
   * On input, calendar and cron_string fields will be compiled into
   * structured_calendar (and maybe interval and timezone_name), so if you
   * Describe a schedule, you'll see only structured_calendar, interval, etc.
   */
  spec?: V1ScheduleSpec;
  /**
   * From action:
   * Action is a oneof field, but we need to encode this in JSON and oneof fields don't work
   * well with JSON. If action is start_workflow, this is set:
   */
  workflowType?: V1WorkflowType;
  /** From state: */
  notes?: string;
  paused?: boolean;
  /** From info (maybe fewer entries): */
  recentActions?: V1ScheduleActionResult[];
  futureActionTimes?: string[];
}

/**
 * ScheduleOverlapPolicy controls what happens when a workflow would be started
 * by a schedule, and is already running.
 *
 *  - SCHEDULE_OVERLAP_POLICY_SKIP: SCHEDULE_OVERLAP_POLICY_SKIP (default) means don't start anything. When the
 * workflow completes, the next scheduled event after that time will be considered.
 *  - SCHEDULE_OVERLAP_POLICY_BUFFER_ONE: SCHEDULE_OVERLAP_POLICY_BUFFER_ONE means start the workflow again soon as the
 * current one completes, but only buffer one start in this way. If another start is
 * supposed to happen when the workflow is running, and one is already buffered, then
 * only the first one will be started after the running workflow finishes.
 *  - SCHEDULE_OVERLAP_POLICY_BUFFER_ALL: SCHEDULE_OVERLAP_POLICY_BUFFER_ALL means buffer up any number of starts to all
 * happen sequentially, immediately after the running workflow completes.
 *  - SCHEDULE_OVERLAP_POLICY_CANCEL_OTHER: SCHEDULE_OVERLAP_POLICY_CANCEL_OTHER means that if there is another workflow
 * running, cancel it, and start the new one after the old one completes cancellation.
 *  - SCHEDULE_OVERLAP_POLICY_TERMINATE_OTHER: SCHEDULE_OVERLAP_POLICY_TERMINATE_OTHER means that if there is another workflow
 * running, terminate it and start the new one immediately.
 *  - SCHEDULE_OVERLAP_POLICY_ALLOW_ALL: SCHEDULE_OVERLAP_POLICY_ALLOW_ALL means start any number of concurrent workflows.
 * Note that with this policy, last completion result and last failure will not be
 * available since workflows are not sequential.
 * @default "SCHEDULE_OVERLAP_POLICY_UNSPECIFIED"
 */
export enum V1ScheduleOverlapPolicy {
  SCHEDULE_OVERLAP_POLICY_UNSPECIFIED = "SCHEDULE_OVERLAP_POLICY_UNSPECIFIED",
  SCHEDULE_OVERLAP_POLICY_SKIP = "SCHEDULE_OVERLAP_POLICY_SKIP",
  SCHEDULE_OVERLAP_POLICY_BUFFER_ONE = "SCHEDULE_OVERLAP_POLICY_BUFFER_ONE",
  SCHEDULE_OVERLAP_POLICY_BUFFER_ALL = "SCHEDULE_OVERLAP_POLICY_BUFFER_ALL",
  SCHEDULE_OVERLAP_POLICY_CANCEL_OTHER = "SCHEDULE_OVERLAP_POLICY_CANCEL_OTHER",
  SCHEDULE_OVERLAP_POLICY_TERMINATE_OTHER = "SCHEDULE_OVERLAP_POLICY_TERMINATE_OTHER",
  SCHEDULE_OVERLAP_POLICY_ALLOW_ALL = "SCHEDULE_OVERLAP_POLICY_ALLOW_ALL",
}

export interface V1SchedulePatch {
  /** If set, trigger one action immediately. */
  triggerImmediately?: V1TriggerImmediatelyRequest;
  /**
   * If set, runs though the specified time period(s) and takes actions as if that time
   * passed by right now, all at once. The overlap policy can be overridden for the
   * scope of the backfill.
   */
  backfillRequest?: V1BackfillRequest[];
  /**
   * If set, change the state to paused or unpaused (respectively) and set the
   * notes field to the value of the string.
   */
  pause?: string;
  unpause?: string;
}

export interface V1SchedulePolicies {
  /**
   * Policy for overlaps.
   * Note that this can be changed after a schedule has taken some actions,
   * and some changes might produce unintuitive results. In general, the later
   * policy overrides the earlier policy.
   */
  overlapPolicy?: V1ScheduleOverlapPolicy;
  /**
   * Policy for catchups:
   * If the Temporal server misses an action due to one or more components
   * being down, and comes back up, the action will be run if the scheduled
   * time is within this window from the current time.
   * This value defaults to 60 seconds, and can't be less than 10 seconds.
   */
  catchupWindow?: string;
  /**
   * If true, and a workflow run fails or times out, turn on "paused".
   * This applies after retry policies: the full chain of retries must fail to
   * trigger a pause here.
   */
  pauseOnFailure?: boolean;
}

/**
 * ScheduleSpec is a complete description of a set of absolute timestamps
 * (possibly infinite) that an action should occur at. The meaning of a
 * ScheduleSpec depends only on its contents and never changes, except that the
 * definition of a time zone can change over time (most commonly, when daylight
 * saving time policy changes for an area). To create a totally self-contained
 * ScheduleSpec, use UTC or include timezone_data.
 *
 * For input, you can provide zero or more of: structured_calendar, calendar,
 * cron_string, interval, and exclude_structured_calendar, and all of them will
 * be used (the schedule will take action at the union of all of their times,
 * minus the ones that match exclude_structured_calendar).
 *
 * On input, calendar and cron_string fields will be compiled into
 * structured_calendar (and maybe interval and timezone_name), so if you
 * Describe a schedule, you'll see only structured_calendar, interval, etc.
 */
export interface V1ScheduleSpec {
  /** Calendar-based specifications of times. */
  structuredCalendar?: V1StructuredCalendarSpec[];
  /**
   * cron_string holds a traditional cron specification as a string. It
   * accepts 5, 6, or 7 fields, separated by spaces, and interprets them the
   * same way as CalendarSpec.
   * 5 fields:         minute, hour, day_of_month, month, day_of_week
   * 6 fields:         minute, hour, day_of_month, month, day_of_week, year
   * 7 fields: second, minute, hour, day_of_month, month, day_of_week, year
   * If year is not given, it defaults to *. If second is not given, it
   * defaults to 0.
   * Shorthands @yearly, @monthly, @weekly, @daily, and @hourly are also
   * accepted instead of the 5-7 time fields.
   * Optionally, the string can be preceded by CRON_TZ=<timezone name> or
   * TZ=<timezone name>, which will get copied to timezone_name. (There must
   * not also be a timezone_name present.)
   * Optionally "#" followed by a comment can appear at the end of the string.
   * Note that the special case that some cron implementations have for
   * treating day_of_month and day_of_week as "or" instead of "and" when both
   * are set is not implemented.
   * @every <interval>[/<phase>] is accepted and gets compiled into an
   * IntervalSpec instead. <interval> and <phase> should be a decimal integer
   * with a unit suffix s, m, h, or d.
   */
  cronString?: string[];
  /** Calendar-based specifications of times. */
  calendar?: V1CalendarSpec[];
  /** Interval-based specifications of times. */
  interval?: V1IntervalSpec[];
  /**
   * Any timestamps matching any of exclude_* will be skipped.
   *
   * use exclude_structured_calendar
   */
  excludeCalendar?: V1CalendarSpec[];
  excludeStructuredCalendar?: V1StructuredCalendarSpec[];
  /**
   * If start_time is set, any timestamps before start_time will be skipped.
   * (Together, start_time and end_time make an inclusive interval.)
   * @format date-time
   */
  startTime?: string;
  /**
   * If end_time is set, any timestamps after end_time will be skipped.
   * @format date-time
   */
  endTime?: string;
  /**
   * All timestamps will be incremented by a random value from 0 to this
   * amount of jitter. Default: 0
   */
  jitter?: string;
  /**
   * Time zone to interpret all calendar-based specs in.
   *
   * If unset, defaults to UTC. We recommend using UTC for your application if
   * at all possible, to avoid various surprising properties of time zones.
   *
   * Time zones may be provided by name, corresponding to names in the IANA
   * time zone database (see https://www.iana.org/time-zones). The definition
   * will be loaded by the Temporal server from the environment it runs in.
   *
   * If your application requires more control over the time zone definition
   * used, it may pass in a complete definition in the form of a TZif file
   * from the time zone database. If present, this will be used instead of
   * loading anything from the environment. You are then responsible for
   * updating timezone_data when the definition changes.
   *
   * Calendar spec matching is based on literal matching of the clock time
   * with no special handling of DST: if you write a calendar spec that fires
   * at 2:30am and specify a time zone that follows DST, that action will not
   * be triggered on the day that has no 2:30am. Similarly, an action that
   * fires at 1:30am will be triggered twice on the day that has two 1:30s.
   *
   * Also note that no actions are taken on leap-seconds (e.g. 23:59:60 UTC).
   */
  timezoneName?: string;
  /** @format byte */
  timezoneData?: string;
}

export interface V1ScheduleState {
  /**
   * Informative human-readable message with contextual notes, e.g. the reason
   * a schedule is paused. The system may overwrite this message on certain
   * conditions, e.g. when pause-on-failure happens.
   */
  notes?: string;
  /** If true, do not take any actions based on the schedule spec. */
  paused?: boolean;
  /**
   * If limited_actions is true, decrement remaining_actions after each
   * action, and do not take any more scheduled actions if remaining_actions
   * is zero. Actions may still be taken by explicit request (i.e. trigger
   * immediately or backfill). Skipped actions (due to overlap policy) do not
   * count against remaining actions.
   */
  limitedActions?: boolean;
  /** @format int64 */
  remainingActions?: string;
}

/**
 * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
 * The payload is not serialized in a user-defined way.
 */
export interface V1SearchAttributes {
  indexedFields?: Record<string, V1Payload>;
}

export interface V1ServerFailureInfo {
  nonRetryable?: boolean;
}

/** @default "SEVERITY_UNSPECIFIED" */
export enum V1Severity {
  SEVERITY_UNSPECIFIED = "SEVERITY_UNSPECIFIED",
  SEVERITY_HIGH = "SEVERITY_HIGH",
  SEVERITY_MEDIUM = "SEVERITY_MEDIUM",
  SEVERITY_LOW = "SEVERITY_LOW",
}

export interface V1SignalExternalWorkflowExecutionCommandAttributes {
  namespace?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  execution?: V1WorkflowExecution;
  /** The workflow author-defined name of the signal to send to the workflow. */
  signalName?: string;
  /** Serialized value(s) to provide with the signal. */
  input?: V1Payloads;
  /** Deprecated */
  control?: string;
  /**
   * Set this to true if the workflow being cancelled is a child of the workflow originating this
   * command. The request will be rejected if it is set to true and the target workflow is *not*
   * a child of the requesting workflow.
   */
  childWorkflowOnly?: boolean;
  /**
   * Headers that are passed by the workflow that is sending a signal to the external
   * workflow that is receiving this signal.
   */
  header?: V1Header;
}

/** @default "SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_UNSPECIFIED" */
export enum V1SignalExternalWorkflowExecutionFailedCause {
  SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_UNSPECIFIED = "SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_UNSPECIFIED",
  SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_EXTERNAL_WORKFLOW_EXECUTION_NOT_FOUND = "SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_EXTERNAL_WORKFLOW_EXECUTION_NOT_FOUND",
  SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_NAMESPACE_NOT_FOUND = "SIGNAL_EXTERNAL_WORKFLOW_EXECUTION_FAILED_CAUSE_NAMESPACE_NOT_FOUND",
}

export interface V1SignalExternalWorkflowExecutionFailedEventAttributes {
  cause?: V1SignalExternalWorkflowExecutionFailedCause;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /**
   * Namespace of the workflow which failed the signal.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  /** @format int64 */
  initiatedEventId?: string;
  /** Deprecated */
  control?: string;
}

export interface V1SignalExternalWorkflowExecutionInitiatedEventAttributes {
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /**
   * Namespace of the to-be-signalled workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  workflowExecution?: V1WorkflowExecution;
  /** name/type of the signal to fire in the external workflow */
  signalName?: string;
  /** Serialized arguments to provide to the signal handler */
  input?: V1Payloads;
  /** Deprecated */
  control?: string;
  /**
   * Workers are expected to set this to true if the workflow they are requesting to cancel is
   * a child of the workflow which issued the request
   */
  childWorkflowOnly?: boolean;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
}

export interface V1SignalWithStartWorkflowExecutionResponse {
  runId?: string;
}

export type V1SignalWorkflowExecutionResponse = object;

export type V1StartBatchOperationResponse = object;

export interface V1StartChildWorkflowExecutionCommandAttributes {
  namespace?: string;
  workflowId?: string;
  workflowType?: V1WorkflowType;
  taskQueue?: V1TaskQueue;
  input?: V1Payloads;
  /** Total workflow execution timeout including retries and continue as new. */
  workflowExecutionTimeout?: string;
  /** Timeout of a single workflow run. */
  workflowRunTimeout?: string;
  /** Timeout of a single workflow task. */
  workflowTaskTimeout?: string;
  /** Default: PARENT_CLOSE_POLICY_TERMINATE. */
  parentClosePolicy?: V1ParentClosePolicy;
  control?: string;
  /** Default: WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE. */
  workflowIdReusePolicy?: V1WorkflowIdReusePolicy;
  retryPolicy?: V1RetryPolicy;
  /** Establish a cron schedule for the child workflow. */
  cronSchedule?: string;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
  memo?: V1Memo;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
}

/** @default "START_CHILD_WORKFLOW_EXECUTION_FAILED_CAUSE_UNSPECIFIED" */
export enum V1StartChildWorkflowExecutionFailedCause {
  START_CHILD_WORKFLOW_EXECUTION_FAILED_CAUSE_UNSPECIFIED = "START_CHILD_WORKFLOW_EXECUTION_FAILED_CAUSE_UNSPECIFIED",
  START_CHILD_WORKFLOW_EXECUTION_FAILED_CAUSE_WORKFLOW_ALREADY_EXISTS = "START_CHILD_WORKFLOW_EXECUTION_FAILED_CAUSE_WORKFLOW_ALREADY_EXISTS",
  START_CHILD_WORKFLOW_EXECUTION_FAILED_CAUSE_NAMESPACE_NOT_FOUND = "START_CHILD_WORKFLOW_EXECUTION_FAILED_CAUSE_NAMESPACE_NOT_FOUND",
}

export interface V1StartChildWorkflowExecutionFailedEventAttributes {
  /**
   * Namespace of the child workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  workflowId?: string;
  workflowType?: V1WorkflowType;
  cause?: V1StartChildWorkflowExecutionFailedCause;
  /** Deprecated */
  control?: string;
  /**
   * Id of the `START_CHILD_WORKFLOW_EXECUTION_INITIATED` event which this event corresponds to
   * @format int64
   */
  initiatedEventId?: string;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
}

export interface V1StartChildWorkflowExecutionInitiatedEventAttributes {
  /**
   * Namespace of the child workflow.
   * SDKs and UI tools should use `namespace` field but server must use `namespace_id` only.
   */
  namespace?: string;
  namespaceId?: string;
  workflowId?: string;
  workflowType?: V1WorkflowType;
  taskQueue?: V1TaskQueue;
  input?: V1Payloads;
  /** Total workflow execution timeout including retries and continue as new. */
  workflowExecutionTimeout?: string;
  /** Timeout of a single workflow run. */
  workflowRunTimeout?: string;
  /** Timeout of a single workflow task. */
  workflowTaskTimeout?: string;
  /** Default: PARENT_CLOSE_POLICY_TERMINATE. */
  parentClosePolicy?: V1ParentClosePolicy;
  /** Deprecated */
  control?: string;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /** Default: WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE. */
  workflowIdReusePolicy?: V1WorkflowIdReusePolicy;
  retryPolicy?: V1RetryPolicy;
  /** If this child runs on a cron schedule, it will appear here */
  cronSchedule?: string;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
  memo?: V1Memo;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
}

export interface V1StartTimeFilter {
  /** @format date-time */
  earliestTime?: string;
  /** @format date-time */
  latestTime?: string;
}

export interface V1StartTimerCommandAttributes {
  /**
   * An id for the timer, currently live timers must have different ids. Typically autogenerated
   * by the SDK.
   */
  timerId?: string;
  /**
   * How long until the timer fires, producing a `TIMER_FIRED` event.
   *
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  startToFireTimeout?: string;
}

export interface V1StartWorkflowExecutionResponse {
  runId?: string;
  /**
   * When `request_eager_execution` is set on the `StartWorkflowExecutionRequest`, the server - if supported - will
   * return the first workflow task to be eagerly executed.
   * The caller is expected to have a worker available to process the task.
   */
  eagerWorkflowTask?: V1PollWorkflowTaskQueueResponse;
}

export interface V1StatusFilter {
  /** - WORKFLOW_EXECUTION_STATUS_RUNNING: Value 1 is hardcoded in SQL persistence. */
  status?: V1WorkflowExecutionStatus;
}

export interface V1StickyExecutionAttributes {
  workerTaskQueue?: V1TaskQueue;
  /**
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  scheduleToStartTimeout?: string;
}

export type V1StopBatchOperationResponse = object;

/**
 * StructuredCalendarSpec describes an event specification relative to the
 * calendar, in a form that's easy to work with programmatically. Each field can
 * be one or more ranges.
 * A timestamp matches if at least one range of each field matches the
 * corresponding fields of the timestamp, except for year: if year is missing,
 * that means all years match. For all fields besides year, at least one Range
 * must be present to match anything.
 * TODO: add relative-to-end-of-month
 * TODO: add nth day-of-week in month
 */
export interface V1StructuredCalendarSpec {
  /** Match seconds (0-59) */
  second?: V1Range[];
  /** Match minutes (0-59) */
  minute?: V1Range[];
  /** Match hours (0-23) */
  hour?: V1Range[];
  /**
   * Match days of the month (1-31)
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: standard name of field --)
   */
  dayOfMonth?: V1Range[];
  /** Match months (1-12) */
  month?: V1Range[];
  /** Match years. */
  year?: V1Range[];
  /** Match days of the week (0-6; 0 is Sunday). */
  dayOfWeek?: V1Range[];
  /** Free-form comment describing the intention of this spec. */
  comment?: string;
}

export interface V1TaskIdBlock {
  /** @format int64 */
  startId?: string;
  /** @format int64 */
  endId?: string;
}

/** See https://docs.temporal.io/docs/concepts/task-queues/ */
export interface V1TaskQueue {
  name?: string;
  /** Default: TASK_QUEUE_KIND_NORMAL. */
  kind?: V1TaskQueueKind;
}

/**
 * - TASK_QUEUE_KIND_NORMAL: Tasks from a normal workflow task queue always include complete workflow history
 * The task queue specified by the user is always a normal task queue. There can be as many
 * workers as desired for a single normal task queue. All those workers may pick up tasks from
 * that queue.
 *  - TASK_QUEUE_KIND_STICKY: A sticky queue only includes new history since the last workflow task, and they are
 * per-worker.
 *
 * Sticky queues are created dynamically by each worker during their start up. They only exist
 * for the lifetime of the worker process. Tasks in a sticky task queue are only available to
 * the worker that created the sticky queue.
 *
 * Sticky queues are only for workflow tasks. There are no sticky task queues for activities.
 * @default "TASK_QUEUE_KIND_UNSPECIFIED"
 */
export enum V1TaskQueueKind {
  TASK_QUEUE_KIND_UNSPECIFIED = "TASK_QUEUE_KIND_UNSPECIFIED",
  TASK_QUEUE_KIND_NORMAL = "TASK_QUEUE_KIND_NORMAL",
  TASK_QUEUE_KIND_STICKY = "TASK_QUEUE_KIND_STICKY",
}

/** Only applies to activity task queues */
export interface V1TaskQueueMetadata {
  /**
   * Allows throttling dispatch of tasks from this queue
   * @format double
   */
  maxTasksPerSecond?: number;
}

export interface V1TaskQueuePartitionMetadata {
  key?: string;
  ownerHostName?: string;
}

export interface V1TaskQueueStatus {
  /** @format int64 */
  backlogCountHint?: string;
  /** @format int64 */
  readLevel?: string;
  /** @format int64 */
  ackLevel?: string;
  /** @format double */
  ratePerSecond?: number;
  taskIdBlock?: V1TaskIdBlock;
}

/**
 *  - TASK_QUEUE_TYPE_WORKFLOW: Workflow type of task queue.
 *  - TASK_QUEUE_TYPE_ACTIVITY: Activity type of task queue.
 * @default "TASK_QUEUE_TYPE_UNSPECIFIED"
 */
export enum V1TaskQueueType {
  TASK_QUEUE_TYPE_UNSPECIFIED = "TASK_QUEUE_TYPE_UNSPECIFIED",
  TASK_QUEUE_TYPE_WORKFLOW = "TASK_QUEUE_TYPE_WORKFLOW",
  TASK_QUEUE_TYPE_ACTIVITY = "TASK_QUEUE_TYPE_ACTIVITY",
}

export type V1TerminateWorkflowExecutionResponse = object;

export type V1TerminatedFailureInfo = object;

export interface V1TimeoutFailureInfo {
  timeoutType?: V1TimeoutType;
  lastHeartbeatDetails?: V1Payloads;
}

/** @default "TIMEOUT_TYPE_UNSPECIFIED" */
export enum V1TimeoutType {
  TIMEOUT_TYPE_UNSPECIFIED = "TIMEOUT_TYPE_UNSPECIFIED",
  TIMEOUT_TYPE_START_TO_CLOSE = "TIMEOUT_TYPE_START_TO_CLOSE",
  TIMEOUT_TYPE_SCHEDULE_TO_START = "TIMEOUT_TYPE_SCHEDULE_TO_START",
  TIMEOUT_TYPE_SCHEDULE_TO_CLOSE = "TIMEOUT_TYPE_SCHEDULE_TO_CLOSE",
  TIMEOUT_TYPE_HEARTBEAT = "TIMEOUT_TYPE_HEARTBEAT",
}

export interface V1TimerCanceledEventAttributes {
  /** Will match the `timer_id` from `TIMER_STARTED` event for this timer */
  timerId?: string;
  /**
   * The id of the `TIMER_STARTED` event itself
   * @format int64
   */
  startedEventId?: string;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /** The id of the worker who requested this cancel */
  identity?: string;
}

export interface V1TimerFiredEventAttributes {
  /** Will match the `timer_id` from `TIMER_STARTED` event for this timer */
  timerId?: string;
  /**
   * The id of the `TIMER_STARTED` event itself
   * @format int64
   */
  startedEventId?: string;
}

export interface V1TimerStartedEventAttributes {
  /** The worker/user assigned id for this timer */
  timerId?: string;
  /**
   * How long until this timer fires
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  startToFireTimeout?: string;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
}

export interface V1TriggerImmediatelyRequest {
  /** Override overlap policy for this one request. */
  overlapPolicy?: V1ScheduleOverlapPolicy;
}

export interface V1UpdateNamespaceInfo {
  description?: string;
  ownerEmail?: string;
  /**
   * A key-value map for any customized purpose.
   * If data already exists on the namespace,
   * this will merge with the existing key values.
   */
  data?: Record<string, string>;
  /**
   * New namespace state, server will reject if transition is not allowed.
   * Allowed transitions are:
   *  Registered -> [ Deleted | Deprecated | Handover ]
   *  Handover -> [ Registered ]
   * Default is NAMESPACE_STATE_UNSPECIFIED which is do not change state.
   */
  state?: V1NamespaceState;
}

export interface V1UpdateNamespaceResponse {
  namespaceInfo?: V1NamespaceInfo;
  config?: V1NamespaceConfig;
  replicationConfig?: V1NamespaceReplicationConfig;
  /** @format int64 */
  failoverVersion?: string;
  isGlobalNamespace?: boolean;
}

export type V1UpdateScheduleResponse = object;

export interface V1UpsertWorkflowSearchAttributesCommandAttributes {
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
}

export interface V1UpsertWorkflowSearchAttributesEventAttributes {
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
}

/**
 * Used by the worker versioning APIs, represents a specific version of something
 * Currently, that's just a whole-worker id. In the future, if we support
 * WASM workflow bundle based versioning, for example, then the inside of this
 * message may become a oneof of different version types.
 */
export interface V1VersionId {
  /** An opaque whole-worker identifier */
  workerBuildId?: string;
}

/** VersionInfo contains details about current and recommended release versions as well as alerts and upgrade instructions. */
export interface V1VersionInfo {
  /** ReleaseInfo contains information about specific version of temporal. */
  current?: V1ReleaseInfo;
  /** ReleaseInfo contains information about specific version of temporal. */
  recommended?: V1ReleaseInfo;
  instructions?: string;
  alerts?: V1Alert[];
  /** @format date-time */
  lastUpdateTime?: string;
}

/**
 * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
 * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
 * run id as a way of saying "target the latest run of the workflow".
 */
export interface V1WorkflowExecution {
  workflowId?: string;
  runId?: string;
}

export interface V1WorkflowExecutionCancelRequestedEventAttributes {
  /**
   * User provided reason for requesting cancellation
   * TODO: shall we create a new field with name "reason" and deprecate this one?
   */
  cause?: string;
  /**
   * TODO: Is this the ID of the event in the workflow which initiated this cancel, if there was one?
   * @format int64
   */
  externalInitiatedEventId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  externalWorkflowExecution?: V1WorkflowExecution;
  /** id of the worker or client who requested this cancel */
  identity?: string;
}

export interface V1WorkflowExecutionCanceledEventAttributes {
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  details?: V1Payloads;
}

export interface V1WorkflowExecutionCompletedEventAttributes {
  /** Serialized result of workflow completion (ie: The return value of the workflow function) */
  result?: V1Payloads;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /** If another run is started by cron, this contains the new run id. */
  newExecutionRunId?: string;
}

export interface V1WorkflowExecutionConfig {
  taskQueue?: V1TaskQueue;
  workflowExecutionTimeout?: string;
  workflowRunTimeout?: string;
  defaultWorkflowTaskTimeout?: string;
}

export interface V1WorkflowExecutionContinuedAsNewEventAttributes {
  /** The run ID of the new workflow started by this continue-as-new */
  newExecutionRunId?: string;
  workflowType?: V1WorkflowType;
  taskQueue?: V1TaskQueue;
  input?: V1Payloads;
  /** Timeout of a single workflow run. */
  workflowRunTimeout?: string;
  /** Timeout of a single workflow task. */
  workflowTaskTimeout?: string;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /** TODO: How and is this used? */
  backoffStartInterval?: string;
  initiator?: V1ContinueAsNewInitiator;
  /**
   * TODO: David are these right?
   * Deprecated. If a workflow's retry policy would cause a new run to start when the current one
   * has failed, this field would be populated with that failure. Now (when supported by server
   * and sdk) the final event will be `WORKFLOW_EXECUTION_FAILED` with `new_execution_run_id` set.
   */
  failure?: V1Failure;
  /** TODO: Is this the result of *this* workflow as it continued-as-new? */
  lastCompletionResult?: V1Payloads;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
  memo?: V1Memo;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
}

export interface V1WorkflowExecutionFailedEventAttributes {
  /** Serialized result of workflow failure (ex: An exception thrown, or error returned) */
  failure?: V1Failure;
  retryState?: V1RetryState;
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /** If another run is started by cron or retry, this contains the new run id. */
  newExecutionRunId?: string;
}

export interface V1WorkflowExecutionFilter {
  workflowId?: string;
  runId?: string;
}

export interface V1WorkflowExecutionInfo {
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  execution?: V1WorkflowExecution;
  type?: V1WorkflowType;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  closeTime?: string;
  /** - WORKFLOW_EXECUTION_STATUS_RUNNING: Value 1 is hardcoded in SQL persistence. */
  status?: V1WorkflowExecutionStatus;
  /** @format int64 */
  historyLength?: string;
  parentNamespaceId?: string;
  /**
   * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
   * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
   * run id as a way of saying "target the latest run of the workflow".
   */
  parentExecution?: V1WorkflowExecution;
  /** @format date-time */
  executionTime?: string;
  memo?: V1Memo;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
  autoResetPoints?: V1ResetPoints;
  taskQueue?: string;
  /** @format int64 */
  stateTransitionCount?: string;
  /** @format int64 */
  historySizeBytes?: string;
}

export interface V1WorkflowExecutionSignaledEventAttributes {
  /** The name/type of the signal to fire */
  signalName?: string;
  /** Will be deserialized and provided as argument(s) to the signal handler */
  input?: V1Payloads;
  /** id of the worker/client who sent this signal */
  identity?: string;
  /**
   * Headers that were passed by the sender of the signal and copied by temporal
   * server into the workflow task.
   */
  header?: V1Header;
}

/** Always the first event in workflow history */
export interface V1WorkflowExecutionStartedEventAttributes {
  workflowType?: V1WorkflowType;
  /**
   * If this workflow is a child, the namespace our parent lives in.
   * SDKs and UI tools should use `parent_workflow_namespace` field but server must use `parent_workflow_namespace_id` only.
   */
  parentWorkflowNamespace?: string;
  parentWorkflowNamespaceId?: string;
  /**
   * Contains information about parent workflow execution that initiated the child workflow these attributes belong to.
   * If the workflow these attributes belong to is not a child workflow of any other execution, this field will not be populated.
   */
  parentWorkflowExecution?: V1WorkflowExecution;
  /**
   * EventID of the child execution initiated event in parent workflow
   * @format int64
   */
  parentInitiatedEventId?: string;
  taskQueue?: V1TaskQueue;
  /** SDK will deserialize this and provide it as arguments to the workflow function */
  input?: V1Payloads;
  /** Total workflow execution timeout including retries and continue as new. */
  workflowExecutionTimeout?: string;
  /** Timeout of a single workflow run. */
  workflowRunTimeout?: string;
  /** Timeout of a single workflow task. */
  workflowTaskTimeout?: string;
  /**
   * Run id of the previous workflow which continued-as-new or retired or cron executed into this
   * workflow.
   */
  continuedExecutionRunId?: string;
  initiator?: V1ContinueAsNewInitiator;
  continuedFailure?: V1Failure;
  lastCompletionResult?: V1Payloads;
  /**
   * This is the run id when the WorkflowExecutionStarted event was written.
   * A workflow reset changes the execution run_id, but preserves this field.
   */
  originalExecutionRunId?: string;
  /** Identity of the client who requested this execution */
  identity?: string;
  /**
   * This is the very first runId along the chain of ContinueAsNew, Retry, Cron and Reset.
   * Used to identify a chain.
   */
  firstExecutionRunId?: string;
  retryPolicy?: V1RetryPolicy;
  /**
   * Starting at 1, the number of times we have tried to execute this workflow
   * @format int32
   */
  attempt?: number;
  /**
   * The absolute time at which the workflow will be timed out.
   * This is passed without change to the next run/retry of a workflow.
   * @format date-time
   */
  workflowExecutionExpirationTime?: string;
  /** If this workflow runs on a cron schedule, it will appear here */
  cronSchedule?: string;
  /**
   * For a cron workflow, this contains the amount of time between when this iteration of
   * the cron workflow was scheduled and when it should run next per its cron_schedule.
   */
  firstWorkflowTaskBackoff?: string;
  memo?: V1Memo;
  /**
   * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
   * The payload is not serialized in a user-defined way.
   */
  searchAttributes?: V1SearchAttributes;
  prevAutoResetPoints?: V1ResetPoints;
  /**
   * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
   * can be propagated between, for example, workflows and activities.
   */
  header?: V1Header;
  /**
   * Version of the child execution initiated event in parent workflow
   * It should be used together with parent_initiated_event_id to identify
   * a child initiated event for global namespace
   * @format int64
   */
  parentInitiatedEventVersion?: string;
}

/**
 * (-- api-linter: core::0216::synonyms=disabled
 *     aip.dev/not-precedent: There is WorkflowExecutionState already in another package. --)
 * - WORKFLOW_EXECUTION_STATUS_RUNNING: Value 1 is hardcoded in SQL persistence.
 * @default "WORKFLOW_EXECUTION_STATUS_UNSPECIFIED"
 */
export enum V1WorkflowExecutionStatus {
  WORKFLOW_EXECUTION_STATUS_UNSPECIFIED = "Unspecified",
  WORKFLOW_EXECUTION_STATUS_RUNNING = "Running",
  WORKFLOW_EXECUTION_STATUS_COMPLETED = "Completed",
  WORKFLOW_EXECUTION_STATUS_FAILED = "Failed",
  WORKFLOW_EXECUTION_STATUS_CANCELED = "Canceled",
  WORKFLOW_EXECUTION_STATUS_TERMINATED = "Terminated",
  WORKFLOW_EXECUTION_STATUS_CONTINUED_AS_NEW = "ContinueAsNew",
  WORKFLOW_EXECUTION_STATUS_TIMED_OUT = "TimedOut",
}

export interface V1WorkflowExecutionTerminatedEventAttributes {
  /** User/client provided reason for termination */
  reason?: string;
  details?: V1Payloads;
  /** id of the client who requested termination */
  identity?: string;
}

export interface V1WorkflowExecutionTimedOutEventAttributes {
  retryState?: V1RetryState;
  /** If another run is started by cron or retry, this contains the new run id. */
  newExecutionRunId?: string;
}

export interface V1WorkflowExecutionUpdateAcceptedEventAttributes {
  /** The instance ID of the update protocol that generated this event. */
  protocolInstanceId?: string;
  /**
   * The message ID of the original request message that initiated this
   * update. Needed so that the worker can recreate and deliver that same
   * message as part of replay.
   */
  acceptedRequestMessageId?: string;
  /**
   * The event ID used to sequence the original request message.
   * @format int64
   */
  acceptedRequestSequencingEventId?: string;
  /**
   * The message payload of the original request message that initiated this
   * update.
   */
  acceptedRequest?: V1Request;
}

export interface V1WorkflowExecutionUpdateCompletedEventAttributes {
  /** The metadata about this update. */
  meta?: V1Meta;
  /** The outcome of executing the workflow update function. */
  outcome?: V1Outcome;
}

export interface V1WorkflowExecutionUpdateRejectedEventAttributes {
  /** The instance ID of the update protocol that generated this event. */
  protocolInstanceId?: string;
  /**
   * The message ID of the original request message that initiated this
   * update. Needed so that the worker can recreate and deliver that same
   * message as part of replay.
   */
  rejectedRequestMessageId?: string;
  /**
   * The event ID used to sequence the original request message.
   * @format int64
   */
  rejectedRequestSequencingEventId?: string;
  /**
   * The message payload of the original request message that initiated this
   * update.
   */
  rejectedRequest?: V1Request;
  /** The cause of rejection. */
  failure?: V1Failure;
}

/**
 * Defines how new runs of a workflow with a particular ID may or may not be allowed. Note that
 * it is *never* valid to have two actively running instances of the same workflow id.
 *
 *  - WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE: Allow starting a workflow execution using the same workflow id.
 *  - WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE_FAILED_ONLY: Allow starting a workflow execution using the same workflow id, only when the last
 * execution's final state is one of [terminated, cancelled, timed out, failed].
 *  - WORKFLOW_ID_REUSE_POLICY_REJECT_DUPLICATE: Do not permit re-use of the workflow id for this workflow. Future start workflow requests
 * could potentially change the policy, allowing re-use of the workflow id.
 *  - WORKFLOW_ID_REUSE_POLICY_TERMINATE_IF_RUNNING: If a workflow is running using the same workflow ID, terminate it and start a new one.
 * If no running workflow, then the behavior is the same as ALLOW_DUPLICATE
 * @default "WORKFLOW_ID_REUSE_POLICY_UNSPECIFIED"
 */
export enum V1WorkflowIdReusePolicy {
  WORKFLOW_ID_REUSE_POLICY_UNSPECIFIED = "WORKFLOW_ID_REUSE_POLICY_UNSPECIFIED",
  WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE = "WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE",
  WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE_FAILED_ONLY = "WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE_FAILED_ONLY",
  WORKFLOW_ID_REUSE_POLICY_REJECT_DUPLICATE = "WORKFLOW_ID_REUSE_POLICY_REJECT_DUPLICATE",
  WORKFLOW_ID_REUSE_POLICY_TERMINATE_IF_RUNNING = "WORKFLOW_ID_REUSE_POLICY_TERMINATE_IF_RUNNING",
}

export interface V1WorkflowPropertiesModifiedEventAttributes {
  /**
   * The `WORKFLOW_TASK_COMPLETED` event which this command was reported with
   * @format int64
   */
  workflowTaskCompletedEventId?: string;
  /**
   * If set, update the workflow memo with the provided values. The values will be merged with
   * the existing memo. If the user wants to delete values, a default/empty Payload should be
   * used as the value for the key being deleted.
   */
  upsertedMemo?: V1Memo;
}

export interface V1WorkflowPropertiesModifiedExternallyEventAttributes {
  /**
   * If set to a nonempty string, future workflow tasks for this workflow shall be dispatched on
   * the provided queue.
   */
  newTaskQueue?: string;
  /** If set, update the workflow task timeout to this value. */
  newWorkflowTaskTimeout?: string;
  /** If set, update the workflow run timeout to this value. May be set to 0 for no timeout. */
  newWorkflowRunTimeout?: string;
  /** If set, update the workflow execution timeout to this value. May be set to 0 for no timeout. */
  newWorkflowExecutionTimeout?: string;
  /**
   * If set, update the workflow memo with the provided values. The values will be merged with
   * the existing memo. If the user wants to delete values, a default/empty Payload should be
   * used as the value for the key being deleted.
   */
  upsertedMemo?: V1Memo;
}

/** See https://docs.temporal.io/docs/concepts/queries/ */
export interface V1WorkflowQuery {
  /** The workflow-author-defined identifier of the query. Typically a function name. */
  queryType?: string;
  /** Serialized arguments that will be provided to the query handler. */
  queryArgs?: V1Payloads;
  /**
   * Headers that were passed by the caller of the query and copied by temporal
   * server into the workflow task.
   */
  header?: V1Header;
}

/** Answer to a `WorkflowQuery` */
export interface V1WorkflowQueryResult {
  /** Did the query succeed or fail? */
  resultType?: V1QueryResultType;
  /** Set when the query succeeds with the results */
  answer?: V1Payloads;
  /** Mutually exclusive with `answer`. Set when the query fails. */
  errorMessage?: string;
}

export interface V1WorkflowTaskCompletedEventAttributes {
  /**
   * The id of the `WORKFLOW_TASK_SCHEDULED` event this task corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /**
   * The id of the `WORKFLOW_TASK_STARTED` event this task corresponds to
   * @format int64
   */
  startedEventId?: string;
  /** Identity of the worker who completed this task */
  identity?: string;
  /** Binary ID of the worker who completed this task */
  binaryChecksum?: string;
  /**
   * ID of the worker who picked up this workflow task, or missing if worker
   * is not using versioning.
   */
  workerVersioningId?: V1VersionId;
  /**
   * Data the SDK wishes to record for itself, but server need not interpret, and does not
   * directly impact workflow state.
   */
  sdkMetadata?: V1WorkflowTaskCompletedMetadata;
}

export interface V1WorkflowTaskCompletedMetadata {
  /**
   * Internal flags used by the core SDK. SDKs using flags must comply with the following behavior:
   * During replay:
   * * If a flag is not recognized (value is too high or not defined), it must fail the workflow
   *   task.
   * * If a flag is recognized, it is stored in a set of used flags for the run. Code checks for
   *   that flag during and after this WFT are allowed to assume that the flag is present.
   * * If a code check for a flag does not find the flag in the set of used flags, it must take
   *   the branch corresponding to the absence of that flag.
   *
   * During non-replay execution of new WFTs:
   * * The SDK is free to use all flags it knows about. It must record any newly-used (IE: not
   *   previously recorded) flags when completing the WFT.
   *
   * SDKs which are too old to even know about this field at all are considered to produce
   * undefined behavior if they replay workflows which used this mechanism.
   *
   * (-- api-linter: core::0141::forbidden-types=disabled
   *     aip.dev/not-precedent: These really shouldn't have negative values. --)
   */
  coreUsedFlags?: number[];
  /**
   * Flags used by the SDK lang. No attempt is made to distinguish between different SDK languages
   * here as processing a workflow with a different language than the one which authored it is
   * already undefined behavior. See `core_used_patches` for more.
   *
   * (-- api-linter: core::0141::forbidden-types=disabled
   *     aip.dev/not-precedent: These really shouldn't have negative values. --)
   */
  langUsedFlags?: number[];
}

/**
 * Workflow tasks can fail for various reasons. Note that some of these reasons can only originate
 * from the server, and some of them can only originate from the SDK/worker.
 *
 *  - WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_COMMAND: Between starting and completing the workflow task (with a workflow completion command), some
 * new command (like a signal) was processed into workflow history. The outstanding task will be
 * failed with this reason, and a worker must pick up a new task.
 *  - WORKFLOW_TASK_FAILED_CAUSE_RESET_STICKY_TASK_QUEUE: The worker wishes to fail the task and have the next one be generated on a normal, not sticky
 * queue. Generally workers should prefer to use the explicit `ResetStickyTaskQueue` RPC call.
 *  - WORKFLOW_TASK_FAILED_CAUSE_NON_DETERMINISTIC_ERROR: The worker encountered a mismatch while replaying history between what was expected, and
 * what the workflow code actually did.
 *  - WORKFLOW_TASK_FAILED_CAUSE_PENDING_CHILD_WORKFLOWS_LIMIT_EXCEEDED: We send the below error codes to users when their requests would violate a size constraint
 * of their workflow. We do this to ensure that the state of their workflow does not become too
 * large because that can cause severe performance degradation. You can modify the thresholds for
 * each of these errors within your dynamic config.
 *
 * Spawning a new child workflow would cause this workflow to exceed its limit of pending child
 * workflows.
 *  - WORKFLOW_TASK_FAILED_CAUSE_PENDING_ACTIVITIES_LIMIT_EXCEEDED: Starting a new activity would cause this workflow to exceed its limit of pending activities
 * that we track.
 *  - WORKFLOW_TASK_FAILED_CAUSE_PENDING_SIGNALS_LIMIT_EXCEEDED: A workflow has a buffer of signals that have not yet reached their destination. We return this
 * error when sending a new signal would exceed the capacity of this buffer.
 *  - WORKFLOW_TASK_FAILED_CAUSE_PENDING_REQUEST_CANCEL_LIMIT_EXCEEDED: Similarly, we have a buffer of pending requests to cancel other workflows. We return this error
 * when our capacity for pending cancel requests is already reached.
 *  - WORKFLOW_TASK_FAILED_CAUSE_BAD_UPDATE_WORKFLOW_EXECUTION_MESSAGE: Workflow execution update message (update.Acceptance, update.Rejection, or update.Response)
 * has wrong format, or missing required fields.
 *  - WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_UPDATE: Similar to WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_COMMAND, but for updates.
 * @default "WORKFLOW_TASK_FAILED_CAUSE_UNSPECIFIED"
 */
export enum V1WorkflowTaskFailedCause {
  WORKFLOW_TASK_FAILED_CAUSE_UNSPECIFIED = "WORKFLOW_TASK_FAILED_CAUSE_UNSPECIFIED",
  WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_COMMAND = "WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_COMMAND",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_SCHEDULE_ACTIVITY_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_SCHEDULE_ACTIVITY_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_REQUEST_CANCEL_ACTIVITY_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_REQUEST_CANCEL_ACTIVITY_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_START_TIMER_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_START_TIMER_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_CANCEL_TIMER_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_CANCEL_TIMER_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_RECORD_MARKER_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_RECORD_MARKER_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_COMPLETE_WORKFLOW_EXECUTION_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_COMPLETE_WORKFLOW_EXECUTION_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_FAIL_WORKFLOW_EXECUTION_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_FAIL_WORKFLOW_EXECUTION_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_CANCEL_WORKFLOW_EXECUTION_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_CANCEL_WORKFLOW_EXECUTION_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_REQUEST_CANCEL_EXTERNAL_WORKFLOW_EXECUTION_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_CONTINUE_AS_NEW_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_CONTINUE_AS_NEW_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_START_TIMER_DUPLICATE_ID = "WORKFLOW_TASK_FAILED_CAUSE_START_TIMER_DUPLICATE_ID",
  WORKFLOW_TASK_FAILED_CAUSE_RESET_STICKY_TASK_QUEUE = "WORKFLOW_TASK_FAILED_CAUSE_RESET_STICKY_TASK_QUEUE",
  WORKFLOW_TASK_FAILED_CAUSE_WORKFLOW_WORKER_UNHANDLED_FAILURE = "WORKFLOW_TASK_FAILED_CAUSE_WORKFLOW_WORKER_UNHANDLED_FAILURE",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_SIGNAL_WORKFLOW_EXECUTION_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_SIGNAL_WORKFLOW_EXECUTION_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_START_CHILD_EXECUTION_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_START_CHILD_EXECUTION_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_FORCE_CLOSE_COMMAND = "WORKFLOW_TASK_FAILED_CAUSE_FORCE_CLOSE_COMMAND",
  WORKFLOW_TASK_FAILED_CAUSE_FAILOVER_CLOSE_COMMAND = "WORKFLOW_TASK_FAILED_CAUSE_FAILOVER_CLOSE_COMMAND",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_SIGNAL_INPUT_SIZE = "WORKFLOW_TASK_FAILED_CAUSE_BAD_SIGNAL_INPUT_SIZE",
  WORKFLOW_TASK_FAILED_CAUSE_RESET_WORKFLOW = "WORKFLOW_TASK_FAILED_CAUSE_RESET_WORKFLOW",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_BINARY = "WORKFLOW_TASK_FAILED_CAUSE_BAD_BINARY",
  WORKFLOW_TASK_FAILED_CAUSE_SCHEDULE_ACTIVITY_DUPLICATE_ID = "WORKFLOW_TASK_FAILED_CAUSE_SCHEDULE_ACTIVITY_DUPLICATE_ID",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_SEARCH_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_SEARCH_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_NON_DETERMINISTIC_ERROR = "WORKFLOW_TASK_FAILED_CAUSE_NON_DETERMINISTIC_ERROR",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_MODIFY_WORKFLOW_PROPERTIES_ATTRIBUTES = "WORKFLOW_TASK_FAILED_CAUSE_BAD_MODIFY_WORKFLOW_PROPERTIES_ATTRIBUTES",
  WORKFLOW_TASK_FAILED_CAUSE_PENDING_CHILD_WORKFLOWS_LIMIT_EXCEEDED = "WORKFLOW_TASK_FAILED_CAUSE_PENDING_CHILD_WORKFLOWS_LIMIT_EXCEEDED",
  WORKFLOW_TASK_FAILED_CAUSE_PENDING_ACTIVITIES_LIMIT_EXCEEDED = "WORKFLOW_TASK_FAILED_CAUSE_PENDING_ACTIVITIES_LIMIT_EXCEEDED",
  WORKFLOW_TASK_FAILED_CAUSE_PENDING_SIGNALS_LIMIT_EXCEEDED = "WORKFLOW_TASK_FAILED_CAUSE_PENDING_SIGNALS_LIMIT_EXCEEDED",
  WORKFLOW_TASK_FAILED_CAUSE_PENDING_REQUEST_CANCEL_LIMIT_EXCEEDED = "WORKFLOW_TASK_FAILED_CAUSE_PENDING_REQUEST_CANCEL_LIMIT_EXCEEDED",
  WORKFLOW_TASK_FAILED_CAUSE_BAD_UPDATE_WORKFLOW_EXECUTION_MESSAGE = "WORKFLOW_TASK_FAILED_CAUSE_BAD_UPDATE_WORKFLOW_EXECUTION_MESSAGE",
  WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_UPDATE = "WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_UPDATE",
}

export interface V1WorkflowTaskFailedEventAttributes {
  /**
   * The id of the `WORKFLOW_TASK_SCHEDULED` event this task corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /**
   * The id of the `WORKFLOW_TASK_STARTED` event this task corresponds to
   * @format int64
   */
  startedEventId?: string;
  /**
   * Workflow tasks can fail for various reasons. Note that some of these reasons can only originate
   * from the server, and some of them can only originate from the SDK/worker.
   *
   *  - WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_COMMAND: Between starting and completing the workflow task (with a workflow completion command), some
   * new command (like a signal) was processed into workflow history. The outstanding task will be
   * failed with this reason, and a worker must pick up a new task.
   *  - WORKFLOW_TASK_FAILED_CAUSE_RESET_STICKY_TASK_QUEUE: The worker wishes to fail the task and have the next one be generated on a normal, not sticky
   * queue. Generally workers should prefer to use the explicit `ResetStickyTaskQueue` RPC call.
   *  - WORKFLOW_TASK_FAILED_CAUSE_NON_DETERMINISTIC_ERROR: The worker encountered a mismatch while replaying history between what was expected, and
   * what the workflow code actually did.
   *  - WORKFLOW_TASK_FAILED_CAUSE_PENDING_CHILD_WORKFLOWS_LIMIT_EXCEEDED: We send the below error codes to users when their requests would violate a size constraint
   * of their workflow. We do this to ensure that the state of their workflow does not become too
   * large because that can cause severe performance degradation. You can modify the thresholds for
   * each of these errors within your dynamic config.
   *
   * Spawning a new child workflow would cause this workflow to exceed its limit of pending child
   * workflows.
   *  - WORKFLOW_TASK_FAILED_CAUSE_PENDING_ACTIVITIES_LIMIT_EXCEEDED: Starting a new activity would cause this workflow to exceed its limit of pending activities
   * that we track.
   *  - WORKFLOW_TASK_FAILED_CAUSE_PENDING_SIGNALS_LIMIT_EXCEEDED: A workflow has a buffer of signals that have not yet reached their destination. We return this
   * error when sending a new signal would exceed the capacity of this buffer.
   *  - WORKFLOW_TASK_FAILED_CAUSE_PENDING_REQUEST_CANCEL_LIMIT_EXCEEDED: Similarly, we have a buffer of pending requests to cancel other workflows. We return this error
   * when our capacity for pending cancel requests is already reached.
   *  - WORKFLOW_TASK_FAILED_CAUSE_BAD_UPDATE_WORKFLOW_EXECUTION_MESSAGE: Workflow execution update message (update.Acceptance, update.Rejection, or update.Response)
   * has wrong format, or missing required fields.
   *  - WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_UPDATE: Similar to WORKFLOW_TASK_FAILED_CAUSE_UNHANDLED_COMMAND, but for updates.
   */
  cause?: V1WorkflowTaskFailedCause;
  /** The failure details */
  failure?: V1Failure;
  /** If a worker explicitly failed this task, it's identity. TODO: What is this set to if server fails the task? */
  identity?: string;
  /** The original run id of the workflow. For reset workflow. */
  baseRunId?: string;
  /** If the workflow is being reset, the new run id. */
  newRunId?: string;
  /**
   * TODO: ?
   * @format int64
   */
  forkEventVersion?: string;
  /** If a worker explicitly failed this task, it's binary id */
  binaryChecksum?: string;
}

export interface V1WorkflowTaskScheduledEventAttributes {
  /** The task queue this workflow task was enqueued in, which could be a normal or sticky queue */
  taskQueue?: V1TaskQueue;
  /**
   * How long the worker has to process this task once receiving it before it times out
   * (-- api-linter: core::0140::prepositions=disabled
   *     aip.dev/not-precedent: "to" is used to indicate interval. --)
   */
  startToCloseTimeout?: string;
  /**
   * Starting at 1, how many attempts there have been to complete this task
   * @format int32
   */
  attempt?: number;
}

export interface V1WorkflowTaskStartedEventAttributes {
  /**
   * The id of the `WORKFLOW_TASK_SCHEDULED` event this task corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /** Identity of the worker who picked up this task */
  identity?: string;
  /** TODO: ? Appears unused? */
  requestId?: string;
  /**
   * True if this workflow should continue-as-new soon because its history size (in
   * either event count or bytes) is getting large.
   */
  suggestContinueAsNew?: boolean;
  /**
   * Total history size in bytes, which the workflow might use to decide when to
   * continue-as-new regardless of the suggestion. Note that history event count is
   * just the event id of this event, so we don't include it explicitly here.
   * @format int64
   */
  historySizeBytes?: string;
}

export interface V1WorkflowTaskTimedOutEventAttributes {
  /**
   * The id of the `WORKFLOW_TASK_SCHEDULED` event this task corresponds to
   * @format int64
   */
  scheduledEventId?: string;
  /**
   * The id of the `WORKFLOW_TASK_STARTED` event this task corresponds to
   * @format int64
   */
  startedEventId?: string;
  timeoutType?: V1TimeoutType;
}

/**
 * Represents the identifier used by a workflow author to define the workflow. Typically, the
 * name of a function. This is sometimes referred to as the workflow's "name"
 */
export interface V1WorkflowType {
  name?: string;
}

export interface V1WorkflowTypeFilter {
  name?: string;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";
import keycloak from "../keycloak";  

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;

    const keycloakInstance = keycloak;
    this.instance.interceptors.request.use(
      async (config) => {
        try {
          await keycloakInstance.updateToken(30); // Update the token if it's going to expire in 30 seconds
          const { token } = keycloakInstance;
          config.headers.set("Authorization", `Bearer ${token}`);
        } catch (error) {
          console.error("Failed to update Keycloak token", error);
          // Handle error, e.g., redirect to login or show a notification
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title temporal/api/workflowservice/v1/service.proto
 * @version version not set
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceGetClusterInfo
     * @summary GetClusterInfo returns information about temporal cluster
     * @request GET:/api/v1/cluster
     */
    workflowServiceGetClusterInfo: (params: RequestParams = {}) =>
      this.request<V1GetClusterInfoResponse, RpcStatus>({
        path: `/api/v1/cluster`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceListNamespaces
     * @summary ListNamespaces returns the information and configuration for all namespaces.
     * @request GET:/api/v1/namespaces
     */
    workflowServiceListNamespaces: (
      query?: {
        /** @format int32 */
        pageSize?: number;
        /** @format byte */
        nextPageToken?: string;
        /**
         * By default namespaces in NAMESPACE_STATE_DELETED state are not included.
         * Setting include_deleted to true will include deleted namespaces.
         * Note: Namespace is in NAMESPACE_STATE_DELETED state when it was deleted from the system but associated data is not deleted yet.
         */
        namespaceFilterIncludeDeleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1ListNamespacesResponse, RpcStatus>({
        path: `/api/v1/namespaces`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description A Namespace is a top level entity within Temporal, and is used as a container for resources like workflow executions, task queues, etc. A Namespace acts as a sandbox and provides isolation for all resources within the namespace. All resources belongs to exactly one namespace.
     *
     * @tags WorkflowService
     * @name WorkflowServiceRegisterNamespace
     * @summary RegisterNamespace creates a new namespace which can be used as a container for all resources.
     * @request POST:/api/v1/namespaces
     */
    workflowServiceRegisterNamespace: (body: V1RegisterNamespaceRequest, params: RequestParams = {}) =>
      this.request<V1RegisterNamespaceResponse, RpcStatus>({
        path: `/api/v1/namespaces`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceDescribeNamespace
     * @summary DescribeNamespace returns the information and configuration for a registered namespace.
     * @request GET:/api/v1/namespaces/{namespace}
     */
    workflowServiceDescribeNamespace: (
      namespace: string,
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1DescribeNamespaceResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Once the namespace is deprecated it cannot be used to start new workflow executions. Existing workflow executions will continue to run on deprecated namespaces. Deprecated.
     *
     * @tags WorkflowService
     * @name WorkflowServiceDeprecateNamespace
     * @summary DeprecateNamespace is used to update the state of a registered namespace to DEPRECATED.
     * @request DELETE:/api/v1/namespaces/{namespace}
     */
    workflowServiceDeprecateNamespace: (
      namespace: string,
      query?: {
        securityToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1DeprecateNamespaceResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * @description (-- api-linter: core::0134::method-signature=disabled aip.dev/not-precedent: UpdateNamespace RPC doesn't follow Google API format. --) (-- api-linter: core::0134::response-message-name=disabled aip.dev/not-precedent: UpdateNamespace RPC doesn't follow Google API format. --)
 *
 * @tags WorkflowService
 * @name WorkflowServiceUpdateNamespace
 * @summary UpdateNamespace is used to update the information and configuration of a registered
namespace.
 * @request PUT:/api/v1/namespaces/{namespace}
 */
    workflowServiceUpdateNamespace: (
      namespace: string,
      body: {
        updateInfo?: V1UpdateNamespaceInfo;
        config?: V1NamespaceConfig;
        replicationConfig?: V1NamespaceReplicationConfig;
        securityToken?: string;
        deleteBadBinary?: string;
        /** promote local namespace to global namespace. Ignored if namespace is already global namespace. */
        promoteNamespace?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1UpdateNamespaceResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceListBatchOperations
     * @summary ListBatchOperations returns the information about a batch operation
     * @request GET:/api/v1/namespaces/{namespace}/batch-operations
     */
    workflowServiceListBatchOperations: (
      namespace: string,
      query?: {
        /**
         * List page size
         * @format int32
         */
        pageSize?: number;
        /**
         * Next page token
         * @format byte
         */
        nextPageToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1ListBatchOperationsResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/batch-operations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceStartBatchOperation
     * @summary StartBatchOperation starts a new batch operation
     * @request POST:/api/v1/namespaces/{namespace}/batch-operations
     */
    workflowServiceStartBatchOperation: (
      namespace: string,
      body: {
        /**
         * Visibility query defines the the group of workflow to apply the batch operation
         * This field and Executions are mutually exclusive
         */
        visibilityQuery?: string;
        /** Job ID defines the unique ID for the batch job */
        jobId?: string;
        /** Reason to perform the batch operation */
        reason?: string;
        /**
         * Executions to apply the batch operation
         * This field and VisibilityQuery are mutually exclusive
         */
        executions?: V1WorkflowExecution[];
        /**
         * BatchOperationTermination sends terminate requests to batch workflows.
         * Keep the parameter in sync with temporal.api.workflowservice.v1.TerminateWorkflowExecutionRequest.
         * Ignore first_execution_run_id because this is used for single workflow operation.
         */
        terminationOperation?: V1BatchOperationTermination;
        /**
         * BatchOperationSignal sends signals to batch workflows.
         * Keep the parameter in sync with temporal.api.workflowservice.v1.SignalWorkflowExecutionRequest.
         */
        signalOperation?: V1BatchOperationSignal;
        /**
         * BatchOperationCancellation sends cancel requests to batch workflows.
         * Keep the parameter in sync with temporal.api.workflowservice.v1.RequestCancelWorkflowExecutionRequest.
         * Ignore first_execution_run_id because this is used for single workflow operation.
         */
        cancellationOperation?: V1BatchOperationCancellation;
        /**
         * BatchOperationDeletion sends deletion requests to batch workflows.
         * Keep the parameter in sync with temporal.api.workflowservice.v1.DeleteWorkflowExecutionRequest.
         */
        deletionOperation?: V1BatchOperationDeletion;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1StartBatchOperationResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/batch-operations`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceDescribeBatchOperation
     * @summary DescribeBatchOperation returns the information about a batch operation
     * @request GET:/api/v1/namespaces/{namespace}/batch-operations/describe
     */
    workflowServiceDescribeBatchOperation: (
      namespace: string,
      query?: {
        /** Batch job id */
        jobId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1DescribeBatchOperationResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/batch-operations/describe`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceStopBatchOperation
     * @summary ListBatchOperations returns the information about a batch operation
     * @request PUT:/api/v1/namespaces/{namespace}/batch-operations/stop
     */
    workflowServiceStopBatchOperation: (
      namespace: string,
      body: {
        /** Batch job id */
        jobId?: string;
        /** Reason to stop a batch operation */
        reason?: string;
        /** Identity of the operator */
        identity?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1StopBatchOperationResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/batch-operations/stop`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceListSchedules
     * @summary List all schedules in a namespace.
     * @request GET:/api/v1/namespaces/{namespace}/schedules
     */
    workflowServiceListSchedules: (
      namespace: string,
      query?: {
        /**
         * How many to return at once.
         * @format int32
         */
        maximumPageSize?: number;
        /**
         * Token to get the next page of results.
         * @format byte
         */
        nextPageToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1ListSchedulesResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/schedules`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags WorkflowService
 * @name WorkflowServiceCreateSchedule
 * @summary Creates a new schedule.
(-- api-linter: core::0133::method-signature=disabled
    aip.dev/not-precedent: CreateSchedule doesn't follow Google API format --)
(-- api-linter: core::0133::response-message-name=disabled
    aip.dev/not-precedent: CreateSchedule doesn't follow Google API format --)
(-- api-linter: core::0133::http-uri-parent=disabled
    aip.dev/not-precedent: CreateSchedule doesn't follow Google API format --)
 * @request POST:/api/v1/namespaces/{namespace}/schedules
 */
    workflowServiceCreateSchedule: (
      namespace: string,
      body: {
        /** The id of the new schedule. */
        scheduleId?: string;
        /** The schedule spec, policies, action, and initial state. */
        schedule?: V1Schedule;
        /** Optional initial patch (e.g. to run the action once immediately). */
        initialPatch?: V1SchedulePatch;
        /** The identity of the client who initiated this request. */
        identity?: string;
        /** A unique identifier for this create request for idempotence. Typically UUIDv4. */
        requestId?: string;
        /** Memo and search attributes to attach to the schedule itself. */
        memo?: V1Memo;
        /**
         * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
         * The payload is not serialized in a user-defined way.
         */
        searchAttributes?: V1SearchAttributes;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1CreateScheduleResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/schedules`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceDescribeSchedule
     * @summary Returns the schedule description and current state of an existing schedule.
     * @request GET:/api/v1/namespaces/{namespace}/schedules/{scheduleId}
     */
    workflowServiceDescribeSchedule: (namespace: string, scheduleId: string, params: RequestParams = {}) =>
      this.request<V1DescribeScheduleResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/schedules/${scheduleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags WorkflowService
 * @name WorkflowServiceDeleteSchedule
 * @summary Deletes a schedule, removing it from the system.
(-- api-linter: core::0135::method-signature=disabled
    aip.dev/not-precedent: DeleteSchedule doesn't follow Google API format --)
(-- api-linter: core::0135::response-message-name=disabled
    aip.dev/not-precedent: DeleteSchedule doesn't follow Google API format --)
 * @request DELETE:/api/v1/namespaces/{namespace}/schedules/{scheduleId}
 */
    workflowServiceDeleteSchedule: (
      namespace: string,
      scheduleId: string,
      query?: {
        /** The identity of the client who initiated this request. */
        identity?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1DeleteScheduleResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/schedules/${scheduleId}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags WorkflowService
 * @name WorkflowServiceUpdateSchedule
 * @summary Changes the configuration or state of an existing schedule.
(-- api-linter: core::0134::response-message-name=disabled
    aip.dev/not-precedent: UpdateSchedule RPC doesn't follow Google API format. --)
(-- api-linter: core::0134::method-signature=disabled
    aip.dev/not-precedent: UpdateSchedule RPC doesn't follow Google API format. --)
 * @request POST:/api/v1/namespaces/{namespace}/schedules/{scheduleId}
 */
    workflowServiceUpdateSchedule: (
      namespace: string,
      scheduleId: string,
      body: {
        /**
         * The new schedule. The four main fields of the schedule (spec, action,
         * policies, state) are replaced completely by the values in this message.
         */
        schedule?: V1Schedule;
        /**
         * This can be the value of conflict_token from a DescribeScheduleResponse,
         * which will cause this request to fail if the schedule has been modified
         * between the Describe and this Update.
         * If missing, the schedule will be updated unconditionally.
         * @format byte
         */
        conflictToken?: string;
        /** The identity of the client who initiated this request. */
        identity?: string;
        /** A unique identifier for this update request for idempotence. Typically UUIDv4. */
        requestId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1UpdateScheduleResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/schedules/${scheduleId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags WorkflowService
 * @name WorkflowServicePatchSchedule
 * @summary Makes a specific change to a schedule or triggers an immediate action.
(-- api-linter: core::0134::synonyms=disabled
    aip.dev/not-precedent: we have both patch and update. --)
 * @request PATCH:/api/v1/namespaces/{namespace}/schedules/{scheduleId}
 */
    workflowServicePatchSchedule: (
      namespace: string,
      scheduleId: string,
      body: {
        patch?: V1SchedulePatch;
        /** The identity of the client who initiated this request. */
        identity?: string;
        /** A unique identifier for this update request for idempotence. Typically UUIDv4. */
        requestId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1PatchScheduleResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/schedules/${scheduleId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceDescribeTaskQueue
     * @summary DescribeTaskQueue returns information about the target task queue.
     * @request GET:/api/v1/namespaces/{namespace}/task-queues/{taskQueue.name}
     */
    workflowServiceDescribeTaskQueue: (
      namespace: string,
      taskQueueName: string,
      query?: {
        /**
         * Default: TASK_QUEUE_KIND_NORMAL.
         *
         *  - TASK_QUEUE_KIND_NORMAL: Tasks from a normal workflow task queue always include complete workflow history
         *
         * The task queue specified by the user is always a normal task queue. There can be as many
         * workers as desired for a single normal task queue. All those workers may pick up tasks from
         * that queue.
         *  - TASK_QUEUE_KIND_STICKY: A sticky queue only includes new history since the last workflow task, and they are
         * per-worker.
         *
         * Sticky queues are created dynamically by each worker during their start up. They only exist
         * for the lifetime of the worker process. Tasks in a sticky task queue are only available to
         * the worker that created the sticky queue.
         *
         * Sticky queues are only for workflow tasks. There are no sticky task queues for activities.
         * @default "TASK_QUEUE_KIND_UNSPECIFIED"
         */
        taskQueueKind?: "TASK_QUEUE_KIND_UNSPECIFIED" | "TASK_QUEUE_KIND_NORMAL" | "TASK_QUEUE_KIND_STICKY";
        /**
         *  - TASK_QUEUE_TYPE_WORKFLOW: Workflow type of task queue.
         *  - TASK_QUEUE_TYPE_ACTIVITY: Activity type of task queue.
         * @default "TASK_QUEUE_TYPE_UNSPECIFIED"
         */
        taskQueueType?: "TASK_QUEUE_TYPE_UNSPECIFIED" | "TASK_QUEUE_TYPE_WORKFLOW" | "TASK_QUEUE_TYPE_ACTIVITY";
        includeTaskQueueStatus?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1DescribeTaskQueueResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/task-queues/${taskQueueName}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceListWorkflowExecutions
     * @summary ListWorkflowExecutions is a visibility API to list workflow executions in a specific namespace.
     * @request GET:/api/v1/namespaces/{namespace}/workflows
     */
    workflowServiceListWorkflowExecutions: (
      namespace: string,
      query?: {
        /** @format int32 */
        pageSize?: number;
        /** @format byte */
        nextPageToken?: string;
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1ListWorkflowExecutionsResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceListArchivedWorkflowExecutions
     * @summary ListArchivedWorkflowExecutions is a visibility API to list archived workflow executions in a specific namespace.
     * @request GET:/api/v1/namespaces/{namespace}/workflows/archived
     */
    workflowServiceListArchivedWorkflowExecutions: (
      namespace: string,
      query?: {
        /** @format int32 */
        pageSize?: number;
        /** @format byte */
        nextPageToken?: string;
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1ListArchivedWorkflowExecutionsResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/archived`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceListClosedWorkflowExecutions
     * @summary ListClosedWorkflowExecutions is a visibility API to list the closed executions in a specific namespace.
     * @request GET:/api/v1/namespaces/{namespace}/workflows/closed
     */
    workflowServiceListClosedWorkflowExecutions: (
      namespace: string,
      query?: {
        /** @format int32 */
        maximumPageSize?: number;
        /** @format byte */
        nextPageToken?: string;
        /** @format date-time */
        startTimeFilterEarliestTime?: string;
        /** @format date-time */
        startTimeFilterLatestTime?: string;
        executionFilterWorkflowId?: string;
        executionFilterRunId?: string;
        typeFilterName?: string;
        /**
         *  - WORKFLOW_EXECUTION_STATUS_RUNNING: Value 1 is hardcoded in SQL persistence.
         * @default "WORKFLOW_EXECUTION_STATUS_UNSPECIFIED"
         */
        statusFilterStatus?:
          | "WORKFLOW_EXECUTION_STATUS_UNSPECIFIED"
          | "WORKFLOW_EXECUTION_STATUS_RUNNING"
          | "WORKFLOW_EXECUTION_STATUS_COMPLETED"
          | "WORKFLOW_EXECUTION_STATUS_FAILED"
          | "WORKFLOW_EXECUTION_STATUS_CANCELED"
          | "WORKFLOW_EXECUTION_STATUS_TERMINATED"
          | "WORKFLOW_EXECUTION_STATUS_CONTINUED_AS_NEW"
          | "WORKFLOW_EXECUTION_STATUS_TIMED_OUT";
      },
      params: RequestParams = {},
    ) =>
      this.request<V1ListClosedWorkflowExecutionsResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/closed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceCountWorkflowExecutions
     * @summary CountWorkflowExecutions is a visibility API to count of workflow executions in a specific namespace.
     * @request GET:/api/v1/namespaces/{namespace}/workflows/count
     */
    workflowServiceCountWorkflowExecutions: (
      namespace: string,
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1CountWorkflowExecutionsResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/count`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceListOpenWorkflowExecutions
     * @summary ListOpenWorkflowExecutions is a visibility API to list the open executions in a specific namespace.
     * @request GET:/api/v1/namespaces/{namespace}/workflows/open
     */
    workflowServiceListOpenWorkflowExecutions: (
      namespace: string,
      query?: {
        /** @format int32 */
        maximumPageSize?: number;
        /** @format byte */
        nextPageToken?: string;
        /** @format date-time */
        startTimeFilterEarliestTime?: string;
        /** @format date-time */
        startTimeFilterLatestTime?: string;
        executionFilterWorkflowId?: string;
        executionFilterRunId?: string;
        typeFilterName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1ListOpenWorkflowExecutionsResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/open`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceDescribeWorkflowExecution
     * @summary DescribeWorkflowExecution returns information about the specified workflow execution.
     * @request GET:/api/v1/namespaces/{namespace}/workflows/{execution.workflowId}/runs/{execution.runId}
     */
    workflowServiceDescribeWorkflowExecution: (
      namespace: string,
      executionWorkflowId: string,
      executionRunId: string,
      params: RequestParams = {},
    ) =>
      this.request<V1DescribeWorkflowExecutionResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${executionWorkflowId}/runs/${executionRunId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags WorkflowService
 * @name WorkflowServiceGetWorkflowExecutionHistory
 * @summary GetWorkflowExecutionHistory returns the history of specified workflow execution. Fails with
`NotFound` if the specified workflow execution is unknown to the service.
 * @request GET:/api/v1/namespaces/{namespace}/workflows/{execution.workflowId}/runs/{execution.runId}/events
 */
    workflowServiceGetWorkflowExecutionHistory: (
      namespace: string,
      executionWorkflowId: string,
      executionRunId: string,
      query?: {
        /** @format int32 */
        maximumPageSize?: number;
        /**
         * If a `GetWorkflowExecutionHistoryResponse` or a `PollWorkflowTaskQueueResponse` had one of
         * these, it should be passed here to fetch the next page.
         * @format byte
         */
        nextPageToken?: string;
        /**
         * If set to true, the RPC call will not resolve until there is a new event which matches
         * the `history_event_filter_type`, or a timeout is hit.
         */
        waitNewEvent?: boolean;
        /**
         * Filter returned events such that they match the specified filter type.
         * Default: HISTORY_EVENT_FILTER_TYPE_ALL_EVENT.
         * @default "HISTORY_EVENT_FILTER_TYPE_UNSPECIFIED"
         */
        historyEventFilterType?:
          | "HISTORY_EVENT_FILTER_TYPE_UNSPECIFIED"
          | "HISTORY_EVENT_FILTER_TYPE_ALL_EVENT"
          | "HISTORY_EVENT_FILTER_TYPE_CLOSE_EVENT";
        skipArchival?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetWorkflowExecutionHistoryResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${executionWorkflowId}/runs/${executionRunId}/events`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags WorkflowService
 * @name WorkflowServiceGetWorkflowExecutionHistoryReverse
 * @summary GetWorkflowExecutionHistoryReverse returns the history of specified workflow execution in reverse 
order (starting from last event). Fails with`NotFound` if the specified workflow execution is 
unknown to the service.
 * @request GET:/api/v1/namespaces/{namespace}/workflows/{execution.workflowId}/runs/{execution.runId}/events/reverse
 */
    workflowServiceGetWorkflowExecutionHistoryReverse: (
      namespace: string,
      executionWorkflowId: string,
      executionRunId: string,
      query?: {
        /** @format int32 */
        maximumPageSize?: number;
        /** @format byte */
        nextPageToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1GetWorkflowExecutionHistoryReverseResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${executionWorkflowId}/runs/${executionRunId}/events/reverse`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceQueryWorkflow
     * @summary QueryWorkflow requests a query be executed for a specified workflow execution.
     * @request POST:/api/v1/namespaces/{namespace}/workflows/{execution.workflowId}/runs/{execution.runId}/query
     */
    workflowServiceQueryWorkflow: (
      namespace: string,
      executionWorkflowId: string,
      executionRunId: string,
      body: {
        /**
         * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
         * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
         * run id as a way of saying "target the latest run of the workflow".
         */
        execution?: object;
        query?: V1WorkflowQuery;
        /**
         * QueryRejectCondition can used to reject the query if workflow state does not satisfy condition.
         * Default: QUERY_REJECT_CONDITION_NONE.
         */
        queryRejectCondition?: V1QueryRejectCondition;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1QueryWorkflowResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${executionWorkflowId}/runs/${executionRunId}/query`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description This result in a new `WORKFLOW_EXECUTION_CANCEL_REQUESTED` event being written to the workflow history and a new workflow task created for the workflow. Fails with `NotFound` if the workflow is already completed or doesn't exist.
 *
 * @tags WorkflowService
 * @name WorkflowServiceRequestCancelWorkflowExecution
 * @summary RequestCancelWorkflowExecution is called by workers when they want to request cancellation of
a workflow execution.
 * @request POST:/api/v1/namespaces/{namespace}/workflows/{workflowExecution.workflowId}/runs/{workflowExecution.runId}/cancel
 */
    workflowServiceRequestCancelWorkflowExecution: (
      namespace: string,
      workflowExecutionWorkflowId: string,
      workflowExecutionRunId: string,
      body: {
        /**
         * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
         * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
         * run id as a way of saying "target the latest run of the workflow".
         */
        workflowExecution?: object;
        /** The identity of the worker/client */
        identity?: string;
        /** Used to de-dupe cancellation requests */
        requestId?: string;
        /**
         * If set, this call will error if the most recent (if no run id is set on
         * `workflow_execution`), or specified (if it is) workflow execution is not part of the same
         * execution chain as this id.
         */
        firstExecutionRunId?: string;
        /** Reason for requesting the cancellation */
        reason?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1RequestCancelWorkflowExecutionResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${workflowExecutionWorkflowId}/runs/${workflowExecutionRunId}/cancel`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags WorkflowService
 * @name WorkflowServiceResetWorkflowExecution
 * @summary ResetWorkflowExecution will reset an existing workflow execution to a specified
`WORKFLOW_TASK_COMPLETED` event (exclusive). It will immediately terminate the current
execution instance.
TODO: Does exclusive here mean *just* the completed event, or also WFT started? Otherwise the task is doomed to time out?
 * @request POST:/api/v1/namespaces/{namespace}/workflows/{workflowExecution.workflowId}/runs/{workflowExecution.runId}/reset
 */
    workflowServiceResetWorkflowExecution: (
      namespace: string,
      workflowExecutionWorkflowId: string,
      workflowExecutionRunId: string,
      body: {
        /**
         * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
         * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
         * run id as a way of saying "target the latest run of the workflow".
         */
        workflowExecution?: object;
        reason?: string;
        /**
         * The id of a `WORKFLOW_TASK_COMPLETED`,`WORKFLOW_TASK_TIMED_OUT`, `WORKFLOW_TASK_FAILED`, or
         * `WORKFLOW_TASK_STARTED` event to reset to.
         * @format int64
         */
        workflowTaskFinishEventId?: string;
        /** Used to de-dupe reset requests */
        requestId?: string;
        /** Reset reapplay(replay) options. */
        resetReapplyType?: V1ResetReapplyType;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1ResetWorkflowExecutionResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${workflowExecutionWorkflowId}/runs/${workflowExecutionRunId}/reset`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This results in a `WORKFLOW_EXECUTION_SIGNALED` event recorded in the history and a workflow task being created for the execution.
     *
     * @tags WorkflowService
     * @name WorkflowServiceSignalWorkflowExecution
     * @summary SignalWorkflowExecution is used to send a signal to a running workflow execution.
     * @request POST:/api/v1/namespaces/{namespace}/workflows/{workflowExecution.workflowId}/runs/{workflowExecution.runId}/signal
     */
    workflowServiceSignalWorkflowExecution: (
      namespace: string,
      workflowExecutionWorkflowId: string,
      workflowExecutionRunId: string,
      body: {
        /**
         * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
         * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
         * run id as a way of saying "target the latest run of the workflow".
         */
        workflowExecution?: object;
        /** The workflow author-defined name of the signal to send to the workflow */
        signalName?: string;
        /** Serialized value(s) to provide with the signal */
        input?: V1Payloads;
        /** The identity of the worker/client */
        identity?: string;
        /** Used to de-dupe sent signals */
        requestId?: string;
        /** Deprecated */
        control?: string;
        /**
         * Headers that are passed with the signal to the processing workflow.
         * These can include things like auth or tracing tokens.
         */
        header?: V1Header;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1SignalWorkflowExecutionResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${workflowExecutionWorkflowId}/runs/${workflowExecutionRunId}/signal`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags WorkflowService
 * @name WorkflowServiceTerminateWorkflowExecution
 * @summary TerminateWorkflowExecution terminates an existing workflow execution by recording a
`WORKFLOW_EXECUTION_TERMINATED` event in the history and immediately terminating the
execution instance.
 * @request POST:/api/v1/namespaces/{namespace}/workflows/{workflowExecution.workflowId}/runs/{workflowExecution.runId}/terminate
 */
    workflowServiceTerminateWorkflowExecution: (
      namespace: string,
      workflowExecutionWorkflowId: string,
      workflowExecutionRunId: string,
      body: {
        /**
         * Identifies a specific workflow within a namespace. Practically speaking, because run_id is a
         * uuid, a workflow execution is globally unique. Note that many commands allow specifying an empty
         * run id as a way of saying "target the latest run of the workflow".
         */
        workflowExecution?: object;
        reason?: string;
        /** Serialized additional information to attach to the termination event */
        details?: V1Payloads;
        /** The identity of the worker/client */
        identity?: string;
        /**
         * If set, this call will error if the most recent (if no run id is set on
         * `workflow_execution`), or specified (if it is) workflow execution is not part of the same
         * execution chain as this id.
         */
        firstExecutionRunId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1TerminateWorkflowExecutionResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${workflowExecutionWorkflowId}/runs/${workflowExecutionRunId}/terminate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description (-- api-linter: core::0136::prepositions=disabled aip.dev/not-precedent: "By" is used to indicate request type. --)
 *
 * @tags WorkflowService
 * @name WorkflowServiceRespondActivityTaskCompletedById
 * @summary See `RecordActivityTaskCompleted`. This version allows clients to record completions by
namespace/workflow id/activity id instead of task token.
 * @request POST:/api/v1/namespaces/{namespace}/workflows/{workflowId}/runs/{runId}/activities/{activityId}/complete
 */
    workflowServiceRespondActivityTaskCompletedById: (
      namespace: string,
      workflowId: string,
      runId: string,
      activityId: string,
      body: {
        /** The serialized result of activity execution */
        result?: V1Payloads;
        /** The identity of the worker/client */
        identity?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1RespondActivityTaskCompletedByIdResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${workflowId}/runs/${runId}/activities/${activityId}/complete`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description (-- api-linter: core::0136::prepositions=disabled aip.dev/not-precedent: "By" is used to indicate request type. --)
 *
 * @tags WorkflowService
 * @name WorkflowServiceRespondActivityTaskFailedById
 * @summary See `RecordActivityTaskFailed`. This version allows clients to record failures by
namespace/workflow id/activity id instead of task token.
 * @request POST:/api/v1/namespaces/{namespace}/workflows/{workflowId}/runs/{runId}/activities/{activityId}/fail
 */
    workflowServiceRespondActivityTaskFailedById: (
      namespace: string,
      workflowId: string,
      runId: string,
      activityId: string,
      body: {
        /** Detailed failure information */
        failure?: V1Failure;
        /** The identity of the worker/client */
        identity?: string;
        /** Additional details to be stored as last activity heartbeat */
        lastHeartbeatDetails?: V1Payloads;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1RespondActivityTaskFailedByIdResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${workflowId}/runs/${runId}/activities/${activityId}/fail`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description It will create the execution with a `WORKFLOW_EXECUTION_STARTED` event in its history and also schedule the first workflow task. Returns `WorkflowExecutionAlreadyStarted`, if an instance already exists with same workflow id.
     *
     * @tags WorkflowService
     * @name WorkflowServiceStartWorkflowExecution
     * @summary StartWorkflowExecution starts a new workflow execution.
     * @request POST:/api/v1/namespaces/{namespace}/workflows/{workflowId}/start
     */
    workflowServiceStartWorkflowExecution: (
      namespace: string,
      workflowId: string,
      body: {
        workflowType?: V1WorkflowType;
        taskQueue?: V1TaskQueue;
        /** Serialized arguments to the workflow. These are passed as arguments to the workflow function. */
        input?: V1Payloads;
        /** Total workflow execution timeout including retries and continue as new. */
        workflowExecutionTimeout?: string;
        /** Timeout of a single workflow run. */
        workflowRunTimeout?: string;
        /** Timeout of a single workflow task. */
        workflowTaskTimeout?: string;
        /** The identity of the client who initiated this request */
        identity?: string;
        /** A unique identifier for this start request. Typically UUIDv4. */
        requestId?: string;
        /** Default: WORKFLOW_ID_REUSE_POLICY_ALLOW_DUPLICATE. */
        workflowIdReusePolicy?: V1WorkflowIdReusePolicy;
        /** The retry policy for the workflow. Will never exceed `workflow_execution_timeout`. */
        retryPolicy?: V1RetryPolicy;
        /** See https://docs.temporal.io/docs/content/what-is-a-temporal-cron-job/ */
        cronSchedule?: string;
        memo?: V1Memo;
        /**
         * A user-defined set of *indexed* fields that are used/exposed when listing/searching workflows.
         * The payload is not serialized in a user-defined way.
         */
        searchAttributes?: V1SearchAttributes;
        /**
         * Contains metadata that can be attached to a variety of requests, like starting a workflow, and
         * can be propagated between, for example, workflows and activities.
         */
        header?: V1Header;
        /**
         * Request to get the first workflow task inline in the response bypassing matching service and worker polling.
         * If set to `true` the caller is expected to have a worker available and capable of processing the task.
         * The returned task will be marked as started and is expected to be completed by the specified
         * `workflow_task_timeout`.
         */
        requestEagerExecution?: boolean;
        /**
         * These values will be available as ContinuedFailure and LastCompletionResult in the
         * WorkflowExecutionStarted event and through SDKs. The are currently only used by the
         * server itself (for the schedules feature) and are not intended to be exposed in
         * StartWorkflowExecution.
         */
        continuedFailure?: V1Failure;
        lastCompletionResult?: V1Payloads;
      },
      params: RequestParams = {},
    ) =>
      this.request<V1StartWorkflowExecutionResponse, RpcStatus>({
        path: `/api/v1/namespaces/${namespace}/workflows/${workflowId}/start`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WorkflowService
     * @name WorkflowServiceGetSearchAttributes
     * @summary GetSearchAttributes is a visibility API to get all legal keys that could be used in list APIs
     * @request GET:/api/v1/search-attributes
     */
    workflowServiceGetSearchAttributes: (params: RequestParams = {}) =>
      this.request<V1GetSearchAttributesResponse, RpcStatus>({
        path: `/api/v1/search-attributes`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}

export function getCsrfTokenFromCookies(): string | null {
  const csrfCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('_csrf='));

  return csrfCookie ? csrfCookie.split('=')[1] : null;
}